// 2024-10-07T09:50:19.188Z  (1728294619188)
export const locale = {
	lang: 'cs',
	data: {
		'ACCOUNTING_VALUE': 'Účetní hodnota',
		'ACCOUNTING_VALUE.COMPUTE_IN_STATES': 'Výpočet pouze ve vybraném pracovním stavu',
		'ACCOUNTING_VALUE.VALUE_AGGREGATION': 'Agregace hodnot',
		'ACCOUNTING_VALUE.VALUE_COMPUTATION': 'Výpočet hodnoty',
		'ACCOUNTING_VALUE.VALUE_SUMMATION': 'Součet hodnot',
		'ACCOUNT_ACTIVATION': 'Aktivace účtu',
		'ACCOUNT_ACTIVATION.CODE': 'Aktivační kód',
		'ACCOUNT_ACTIVATION.CODE.RESEND': 'Znovu odeslat aktivační kód',
		'ACCOUNT_ACTIVATION.INTRO': 'Vyplňte prosím aktivační kód, který jste obdrželi e -mailem',
		'ACID': 'Kyselina',
		'ACTIVATE': 'Aktivní',
		'ACTIVATE.SELECTED': 'Aktivovat vybrané',
		'ACTIVE': 'Aktivní',
		'ACTIVITIES.DAILY': 'Denní činnosti',
		'ACTIVITIES.EXPORT': 'Vývozní činnosti',
		'ACTIVITIES.NO': 'Žádné aktivity',
		'ACTIVITIES.WEEKLY': 'Týdenní aktivity',
		'ACTIVITY': 'Činnosti',
		'ACTIVITY.EXPORT_DETAILS': 'Exportovat vybranou činnost',
		'ACTIVITY.NO_FIELDS_WORKED': 'Na polích nebyla provedena žádná práce',
		'ADAPTER': 'Adaptér',
		'ADAPTER.ASSIGN': 'Přiřadit adaptér',
		'ADAPTER.ASSIGN.FAILURE': 'Při párování adaptéru došlo k chybě',
		'ADAPTER.ASSIGN.SUCCESS': 'Adaptér úspěšně přiřazen',
		'ADAPTER.ASSIGNED_MACHINE': 'Přidělený stroj',
		'ADAPTER.ASSIGNMENT': 'Přiřazení adaptérů ke strojům',
		'ADAPTER.CHOSEN': 'Vybraný adaptér',
		'ADAPTER.LOAD.FAILURE': 'Při načítání adaptérů došlo k chybě',
		'ADAPTER.NO': 'Žádný adaptér',
		'ADAPTER.NONE_AVAILABLE': 'Není k dispozici žádný adaptér',
		'ADAPTER.PAIR_INFO': 'Vyberte odpovídající adaptér. Již přiřazené adaptéry budou přepsány novým zařízením Nová konfigurace se automaticky načte při příštím restartu adaptéru.',
		'ADAPTER.PREVIOUS': 'Předchozí adaptér',
		'ADAPTERS.NO': 'Žádné adaptéry',
		'ADBLUE.LEVEL': 'Úroveň AdBlue',
		'ADD': 'Přidat',
		'ADDITIONAL_VALUE': 'Dodatečná hodnota',
		'ADDITIVE': 'Aditivní',
		'ADDRESS': 'Adresa',
		'ALL': ' Všechny ',
		'ALL_DEVICES': 'Celková zařízení',
		'AMOUNT': 'Množství',
		'AMOUNT.INVALID': 'Částka neplatná',
		'AMOUNTS': 'Částky',
		'APPLY': 'použít',
		'ARCHIVE': 'Archív',
		'ARCHIVE.SELECTED': 'Vybraný archív',
		'AREA': 'Oblast',
		'AREA.FIELD': 'Plocha',
		'AREA.LOCATION': 'Umístění v oblasti',
		'AREA.PERFORMANCE': 'Plocha za h',
		'AREA.PROCESSED': 'Zpracovaná plocha',
		'AREA.TOTAL': 'Celková plocha',
		'AREA.WORKED': 'Obdělávaná oblast',
		'ASSIGN': 'Přiřadit',
		'AUTH.REMEMBER_ME': 'Zapamatovat si mě',
		'BACK': 'Zpět',
		'BALES': 'Bales',
		'BASIC_DATA': 'Základní údaje',
		'BEACON': 'Čip',
		'BEACON.ASSIGN': 'Přiřadit čip',
		'BEACON.ASSIGN.SUCCESS': 'Čip byl úspěšně přiřazen',
		'BEACON.ASSIGNED_EMPLOYEE': 'Přiřadit zaměstnanecPřiřadit zaměstnance',
		'BEACON.ASSIGNED_IMPLEMENT': 'Přiřadit nářadí',
		'BEACON.ASSIGN_TO_EMPLOYEE': 'Přiřadit čip zaměstnanci',
		'BEACON.ASSIGN_TO_IMPLEMENT': 'Přiřadit čip k nářadí',
		'BEACON.CHOSEN': 'Vybraný čip',
		'BEACON.ERROR': 'Při párování čipu došlo k chybě',
		'BEACON.LOAD_ERROR': 'Při načítání čipu došlo k chybě',
		'BEACON.NONE_AVAILABLE': 'Není k dispozici žádný čip',
		'BEACON.NO_BEACON': 'Žádný čip',
		'BEACON.PAIR_INFO_EMPLOYEE': 'Vyberte odpovídající čip. Již přiřazené čipy budou přepsány aktuálním zaměstnancem.',
		'BEACON.PAIR_INFO_IMPLEMENT': 'Vyberte odpovídající čip. Již přiřazené čipy budou přepsány aktuálním zařízením.',
		'BEACON.PREVIOUS': 'Předchozí čip',
		'BEACONS': 'Čipy',
		'BUILD_YEAR': 'Rok výroby',
		'BUILD_YEAR.INVALID': 'Rok výroby je neplatný',
		'CAN.STATUS': 'Stav CAN',
		'CANCEL': 'Zrušit',
		'CHANGE': 'Změnit',
		'CHANGE.NO': 'Beze změny',
		'CHOOSE_ALL': 'Vyberte vše',
		'CHOOSE_ROLE': 'Vyberte roli',
		'CHRONOLOGICAL': 'Chronologické pořadí',
		'CLICK_PROCESS': 'Vyber proces pro více detailů',
		'CLOSE': 'Zavřít',
		'CO2.EMISSION': 'Emise CO2',
		'CO2.PER': 'Množství CO2 na ha',
		'CO2.TOTAL': 'Celkové množství CO2',
		'COLOR': 'Barva',
		'COMMENT': 'Poznámka',
		'CONDITION': 'Stav',
		'CONFIRM': 'Potvrdit',
		'CONFIRM_PASSWORD': 'Potvrďte heslo',
		'CONNECT': 'Připojit',
		'CONTACT_PERSON': 'Kontaktní osoba',
		'CONTINUE': 'Pokračovat',
		'COST': 'Náklady',
		'COST.INVALID': 'Náklady neplatné',
		'COST.OVERALL': 'Celkové náklady',
		'COST.OVERALL.ARRIVAL': 'Celkové náklady na příjezd',
		'COST.OVERALL.DRIVER': 'Celkové náklady',
		'COST.OVERALL.FIELD_TIME': 'Celkové náklady v terénu',
		'COST.OVERALL.IMPLEMENTS': 'Celkové náklady na implementaci',
		'COST.OVERALL.MACHINES': 'Celkové náklady na stroje',
		'COST.OVERALL.PREPARATION': 'Celková příprava nákladů',
		'COST.TOTAL': 'Celkové náklady',
		'COSTS': 'Náklady',
		'COST_RATE': 'Sazba nákladů',
		'COUNTRY': 'Země',
		'COVERAGE': 'Coverage',
		'COVERAGE.MAP': 'Mapa pokrytí',
		'COVERAGE.MAP.SETTINGS': 'Nastavení mapy pokrytí',
		'COVERAGE.MAP.ZONES': 'Zóny',
		'CREATED': 'Vytvořeno',
		'CREATE_USER': 'Vytvořit uživatele',
		'CROP.TYPE': 'Plodina',
		'CROP.NO_CROP': 'Žádná plodina',
		'CURRENCY': 'Měna',
		'CUSTOMER': 'Zákazník',
		'CUSTOMER.ADD': 'Přidat nového zákazníka',
		'CUSTOMER.ADD.SUCCESS': 'Zákazník úspěšně přidán',
		'CUSTOMER.ASSIGN': 'Přiřadit zákazníka',
		'CUSTOMER.DELETE.QUESTION': 'Opravdu chcete zákazníka odstranit?',
		'CUSTOMER.DELETE.SUCCESS': 'Zákazník byl smazán',
		'CUSTOMER.DETAILS': 'Podrobnosti o zákazníkovi',
		'CUSTOMER.EDIT': 'Upravit zákazníka',
		'CUSTOMER.EDIT.SUCCESS': 'Zákazník úspěšně editován',
		'CUSTOMER.NAME': 'Jméno zákazníka',
		'CUSTOMER.NO': 'Žádný zákazník',
		'CUSTOMER.NOT_SELECTED': 'Nebyl vybrán žádný zákazník',
    'CUSTOMER.NO.ASSIGNEE': 'Žádný zákazník',
		'CUSTOMER.SELECT': 'Vyberte zákazníka',
		'CUSTOMERS': 'Zákazníci',
		'CUSTOMERS.ALL': 'Všichni zákazníci',
		'CUSTOMERS.DELETE.FAILURE': 'Některé zákazníky nebylo možné vymazat',
		'CUSTOMERS.DELETE.QUESTION': 'Chcete vymazat vybrané zákazníky?',
		'CUSTOMERS.DELETE.SUCCESS': 'Zákazníci byli úspěšně vymazáni',
		'CUSTOMERS.MANAGEMENT': 'Správa zákazníků',
		'CUSTOMERS.NO': 'Žádní zákazníci',
		'CUSTOMERS.SELECTED': 'Vybraní zákazníci',
		'CUSTOM_LABELING': 'Vlastní značení',
		'CUSTOM_LABELING.ADD_WORKSTATE': 'Přiřadit  novou pracovní stanici',
		'CUSTOM_LABELING.DEFINE_FOR_IMPLEMENT': 'Zadejte vlastní označení pro vybraný nástroj.',
		'CUSTOM_LABELING.DEFINE_INDIVIDUAL_CONDITION': 'Definujte vlastní podmínky pro štítek.',
		'CUSTOM_LABELING.EDIT.SUCCESS': 'Úprava vlastního označování byla úspěšná',
		'CUSTOM_LABELING.INDIVIDUAL_CONDITION': 'Individuální stav',
		'CUSTOM_LABELING.ISOBUS_OVERRIDE': 'Povolení přepisu pomocí podmínek ISOBUS',
		'CUSTOM_LABELING.NO_LABELS_AVAILABLE': 'Není k dispozici žádné označení',
		'DASHBOARD.GPS_DATA.NO': 'Žádná data GPS',
		'DASHBOARD.MACHINE_POSITIONS.LOAD.FAILURE': 'Při načítání pozic stroje došlo k chybě',
		'DATA': 'Data',
		'DATA.ARCHIVED.WARNING': 'Podkladová data jsou částečně nebo zcela archivována',
		'DATA.EXPORT': 'Export dat',
		'DATA.INPUT': 'Data input',
		'DATA.UPDATING.WARNING': 'Podkladové údaje se aktualizují',
		'DATA_PREPARATION': 'Příprava dat',
		'DATE': 'Datum',
		'DATE.APRIL': 'Duben',
		'DATE.AUGUST': 'Srpen',
		'DATE.DECEMBER': 'Prosinec',
		'DATE.FEBRUARY': 'Únor',
		'DATE.FRIDAY': 'Pátek',
		'DATE.FROM': 'Od',
		'DATE.JANUARY': 'Leden/Január',
		'DATE.JULY': 'Červenec/Júl',
		'DATE.JUNE': 'Červen/Jún',
		'DATE.MARCH': 'Březen/Marec',
		'DATE.MAY': 'Květen/Máj',
		'DATE.MONDAY': 'Pondělí',
		'DATE.NOVEMBER': 'Listopad/November',
		'DATE.OCTOBER': 'Říjen/Október',
		'DATE.PERIOD': 'Doba',
		'DATE.RANGE': 'Rozsah dat',
		'DATE.SATURDAY': 'Sobota',
		'DATE.SEPTEMBER': 'Září/September',
		'DATE.SUNDAY': 'Neděle',
		'DATE.THURSDAY': 'Čtvrtek',
		'DATE.TUESDAY': 'Úterý',
		'DATE.UNTIL': 'Až do',
		'DATE.WEDNESDAY': 'Středa',
		'DAY.CURRENT': 'Aktuální den',
		'DAY.NEXT': 'Další den',
		'DAY.PREVIOUS': 'Předchozí den',
		'DAY.SELECTED': 'Vybraný den',
		'DAYS': 'Dny',
		'DAY_ACTIVITIES': 'Denní činnosti',
		'DEACTIVATE': 'Deaktivovat',
		'DEACTIVATE.SELECTED': 'Deaktivovat vybrané',
		'DEADLINE': 'Termín',
		'DEADLINE.ADD': 'Přidejte termín',
		'DEADLINE.ADD.SUCCESS': 'Termín byl úspěšně přidán',
		'DEADLINE.DELETE.SUCCESS': 'Termín úspěšně smazán',
		'DEADLINE.DONE': 'Dokončit',
		'DEADLINE.DUE': 'Termín splatnosti',
		'DEADLINE.DUE_IN_AT': 'Splatnost v/ve',
		'DEADLINE.EDIT': 'Termín úprav',
		'DEADLINE.EDIT.SUCCESS': 'Termín byl upraven',
		'DEADLINE.IS_CLOSE': 'Tento termín se blíží',
		'DEADLINE.IS_OVERDUE': 'Tato lhůta již uplynula',
		'DEADLINE.OPEN': 'Otevřený',
		'DEADLINE.PROCESS.SUCCESS': 'Úspěšně zpracovaný termín',
		'DEADLINE.PROCESSED': 'Zpracováno',
		'DEADLINE.PROCESSED.SUCCESS': 'Termín úspěšně zpracován',
		'DEADLINE.WARN': 'Termín se blíží',
		'DEADLINES': 'Termíny',
		'DEADLINES.NO': 'Žádné termíny',
		'DEFINE_ROLE': 'Definujte roli',
		'DELETE': 'Vymazat',
		'DELETE.SELECTED': 'Smazat vybrané',
		'DELETED': 'Smazáno',
		'DESCRIPTION': 'Popis',
		'DIAGRAM': 'Schéma',
		'DISPLAY': 'Zobrazit',
		'DISPLAY_TRACK': 'Zobrazit stopu',
		'DISTANCE': 'Vzdálenost',
		'DISTANCE.TOTAL': 'Celková vzdálenost',
		'DISTANCE.WORKED': 'Odpracovaná vzdálenost',
		'DOWNLOAD': 'Stažení',
		'DRIVER': 'Řidič',
		'DRIVER.EDIT': 'Upravit ovladač',
		'DRIVER.FIXED': 'Stálý řidič',
		'DRIVER.NO': 'Žádný řidič',
		'DRIVER.REMOVE': 'Odstranění ovladače',
		'DRIVERS': 'Řidiči',
		'DRIVERS.ALL': 'Všichni řidiči',
		'DRIVER_SCAN_DISABLED': 'Řidičův čip není aktivní',
		'DURATION': 'Doba trvání',
		'DURATION.WORKED': 'Pracovní doba',
		'EDIT': 'Upravit',
		'EDIT.SELECTED': 'Upravit vybrané',
		'EDIT_USER': 'Upravit uživatele',
		'EMAIL': 'Kontaktní e-mail',
		'EMAIL.ACTIVATE': 'Aktivujte e -mail',
		'EMAIL.ACTIVATE.CODE': 'Aktivační kód',
		'EMAIL.ACTIVATE.EXPLANATION': 'Pokud jste změnili svou e -mailovou adresu, zašleme vám aktivační kód na vaši novou adresu.',
		'EMAIL.CHANGE': 'Změnit e-mail',
		'EMAIL.CHANGE.SUCCESS': 'E -mail byl úspěšně změněn',
		'EMAIL.CONFIRM': 'Potvrzení e-mailu',
		'EMAIL.CURRENT': 'Současný email',
		'EMAIL.INVALID': 'E -mail je neplatný',
		'EMAIL.NEW': 'Nový e-mail',
		'EMAIL.NO_MATCH': 'E-maily se neshodují',
		'EMPLOYEE': 'Zaměstnanec',
		'EMPLOYEE.ACTIVATE.QUESTION': 'Opravdu chcete zaměstnance aktivovat?',
		'EMPLOYEE.ADD': 'Přidat zaměstnance',
		'EMPLOYEE.ADD.SUCCESS': 'Zaměstnanec byl úspěšně přidán',
		'EMPLOYEE.CREATE': 'Vytvořit zaměstnance',
		'EMPLOYEE.CREATE.SUCCESS': 'Zaměstnanec byl úspěšně vytvořen',
		'EMPLOYEE.DEACTIVATE.QUESTION': 'Opravdu chcete zaměstnance deaktivovat?',
		'EMPLOYEE.DELETE.QUESTION': 'Opravdu chcete odebrat zaměstnance?',
		'EMPLOYEE.EDIT': 'Upravit zaměstnance',
		'EMPLOYEE.EDIT.SUCCESS': 'Zaměstnanec byl úspěšně upraven',
		'EMPLOYEE.ROLE': 'Role zaměstnance',
		'EMPLOYEE.ROLE_OF': 'Role zaměstnance',
		'EMPLOYEES': 'Pracovníci',
		'EMPLOYEES.ACTIVATE.QUESTION': 'Opravdu chcete aktivovat zaměstnance?',
		'EMPLOYEES.ACTIVATE.SUCCESS': 'Pracovníci se úspěšně aktivovali',
		'EMPLOYEES.ALL': 'Všichni Pracovníci',
		'EMPLOYEES.DEACTIVATE.FAILURE': 'Některé Pracovníci nebylo možné deaktivovat.',
		'EMPLOYEES.DEACTIVATE.QUESTION': 'Opravdu chcete deaktivovat vybrané zaměstnance?',
		'EMPLOYEES.DEACTIVATE.SUCCESS': 'Pracovníci byli deaktivováni',
		'EMPLOYEES.DELETE.FAILURE': 'Některé Pracovníci nebylo možné odstranit.',
		'EMPLOYEES.DELETE.QUESTION': 'Opravdu chcete smazat vybrané zaměstnance',
		'EMPLOYEES.DELETE.SUCCESS': 'Pracovníci vymazáni',
		'EMPLOYEES.MANAGEMENT': 'Správa zaměstnanců',
		'EMPLOYEES.NO': 'Žádní Pracovníci',
		'EMPLOYEES.NOT_SELECTED': 'Nebyli vybráni žádní Pracovníci',
		'EMPLOYEES.SELECTED': 'Vybraní Pracovníci',
		'EMPLOYER.NO': 'Žádný zaměstnavatel',
		'EMPLOYER.NOT_SELECTED': 'Nebyl vybrán žádný zaměstnavatel',
		'EMPLOYES.NO': 'Žádní Pracovníci',
		'END_DRAW_MODE': 'Režim kreslení zrušen',
		'ENTERPRISE': 'Podnik',
		'ENTERPRISE.ADD': 'Přidat podnik',
		'ENTERPRISE.ADD.EMPLOYER_REQUIRED': 'Musíte přidat zaměstnavatele',
		'ENTERPRISE.ADDED.SUCCESS': 'Podnik byl úspěšně přidán',
		'ENTERPRISE.ADD.SUCCESS': 'Úspěšně přidáno do podniku',
		'ENTERPRISE.ENTER_ACCESS_TOKEN': 'Zadejte přístupový kód pro podnik.',
		'ENTERPRISE.NAME': 'Název podniku',
		'ENTERPRISE.NOT_SELECTED': 'Nebyl vybrán žádný podnik',
		'ENTERPRISE.OF': 'Podnik:',
		'ENTERPRISE.SETTINGS': 'Podnikové nastavení',
		'ENTERPRISE.SETTINGS.CONFIGURATION_UPDATE.SUCCESS': 'Konfigurace podniku byla úspěšně aktualizována',
		'ENTERPRISE.SETTINGS.MACHINES_SYNC.SUCCESS': 'Stroje byly úspěšně synchronizovány',
		'ENTERPRISE_LICENSE.EMPLOYEES': 'Pracovníci zaměstnanců',
		'ENTERPRISE_LICENSE.LICENSE': 'Licence',
		'ENTERPRISE_LICENSE.MACHINE': 'Licence stroje',
		'ENTERPRISE_LICENSE.MACHINES': 'Licence na stroje',
		'ENTERPRISE_MIN': 'Název podniku musí obsahovat alespoň 3 znaky',
		'ENTERPRISE_NAME_REQUIRED': 'Je vyžadován název podniku',
		'ENTERPRISE_SELECTION.ADD_ENTERPRISE': 'Přidat podnik',
		'ENTERPRISE_SELECTION.LICENSE_EXPIRED': 'Licence vypršela',
		'ENTERPRISE_SELECTION.REQUEST_TEST_ACCOUNT': 'Požádejte o testovací účet',
		'ENTERPRISE_STATISTICS': 'Podniková statistika',
		'ENTERPRISE_STATISTICS.COST_DIAGRAMM': 'Nákladový diagram',
		'ENTERPRISE_STATISTICS.PROCESS_DIVISION': 'Rozdělení procesů',
		'ENUM.ACCOUNTING_COMP_MODE.A': 'Vše',
		'ENUM.ACCOUNTING_COMP_MODE.WT': 'Práce / přeprava',
		'ENUM.ACCOUNTING_MODE.AVG': 'Průměrný',
		'ENUM.ACCOUNTING_MODE.MAX': 'Maximum',
		'ENUM.ACCOUNTING_MODE.MED': 'Medián',
		'ENUM.ACCOUNTING_MODE.MIN': 'Minimální',
		'ENUM.ACCOUNTING_MODE.SUM': 'Součet',
		'ENUM.ACCOUNTING_VALUE_MODE.ABSDIF': 'Absolutní rozdíl',
		'ENUM.ACCOUNTING_VALUE_MODE.DIR': 'Přímo',
		'ENUM.ACCOUNTING_VALUE_MODE.NEGDIF': 'Negativní rozdíl',
		'ENUM.ACCOUNTING_VALUE_MODE.POSDIF': 'Pozitivní rozdíl',
		'ENUM.ACCOUNTING_VALUE_MODE.TIMACT': 'Aktivní čas',
		'ENUM.BEACONTYPE.BDrv': 'Maják pro řidiče',
		'ENUM.BEACONTYPE.BImpl': 'Implementace majáku',
		'ENUM.CAN_IDENTIFIER.A1': 'Analogový',
		'ENUM.CAN_IDENTIFIER.A2': 'Analogový 2',
		'ENUM.CAN_IDENTIFIER.A3': 'Analogový 3',
		'ENUM.CAN_IDENTIFIER.A4': 'Analogový  4',
		'ENUM.CAN_IDENTIFIER.AUX0_Ext_Fl': 'AUX0 externí tok',
		'ENUM.CAN_IDENTIFIER.AUX0_Ret_Fl': 'AUX0 zpětný tok',
		'ENUM.CAN_IDENTIFIER.AUX1_Ext_Fl': 'AUX1 externí tok',
		'ENUM.CAN_IDENTIFIER.AUX1_Ret_Fl': 'AUX1 zpětný tok',
		'ENUM.CAN_IDENTIFIER.AUX2_Ext_Fl': 'AUX2 externí tok',
		'ENUM.CAN_IDENTIFIER.AUX2_Ret_Fl': 'AUX2 zpětný tok',
		'ENUM.CAN_IDENTIFIER.AUX3_Ext_Fl': 'AUX3 externí tok',
		'ENUM.CAN_IDENTIFIER.AUX3_Ret_Fl': 'AUX3 zpětný tok',
		'ENUM.CAN_IDENTIFIER.AUX4_Ext_Fl': 'AUX4 externí tok',
		'ENUM.CAN_IDENTIFIER.AUX4_Ret_Fl': 'AUX4 zpětný tok',
		'ENUM.CAN_IDENTIFIER.Ag1avg': 'Úhel 1 průměr',
		'ENUM.CAN_IDENTIFIER.Ag1max': 'Úhel 1 max',
		'ENUM.CAN_IDENTIFIER.Ag1min': 'Úhel 1 min',
		'ENUM.CAN_IDENTIFIER.Ag2avg': 'Úhel 2 průměr',
		'ENUM.CAN_IDENTIFIER.Ag2max': 'Úhel  2 max',
		'ENUM.CAN_IDENTIFIER.Ag2min': 'Úhel 2 min',
		'ENUM.CAN_IDENTIFIER.Ag3avg': 'Úhel 3 průměr',
		'ENUM.CAN_IDENTIFIER.Ag3max': 'Úhel 3 max',
		'ENUM.CAN_IDENTIFIER.Ag3min': 'Úhel 3 min',
		'ENUM.CAN_IDENTIFIER.ApplAci': 'Aplikovaná kyselina',
		'ENUM.CAN_IDENTIFIER.ApplAdd': 'Aplikovaná aditiva',
		'ENUM.CAN_IDENTIFIER.ApplSlu': 'Aplikovaná močůvka',
		'ENUM.CAN_IDENTIFIER.AxleWeight_1': 'Hmotnost nápravy 1',
		'ENUM.CAN_IDENTIFIER.AxleWeight_2': 'Hmotnost nápravy 2',
		'ENUM.CAN_IDENTIFIER.C1': 'IO-Box: Čítač 1',
		'ENUM.CAN_IDENTIFIER.C2': 'IO-Box: Čítač 2',
		'ENUM.CAN_IDENTIFIER.Chop_Act': 'Vrtulník',
		'ENUM.CAN_IDENTIFIER.Circ_1_Stat': 'Circ_1_Stat',
		'ENUM.CAN_IDENTIFIER.Circ_2A_Stat': ' Circ_2A_Stat ',
		'ENUM.CAN_IDENTIFIER.Circ_2B_Stat': 'Circ_2B_Stat ',
		'ENUM.CAN_IDENTIFIER.Circ_3_Stat': ' Circ_3_Stat ',
		'ENUM.CAN_IDENTIFIER.Circ_4_Stat': 'Circ_4_Stat ',
		'ENUM.CAN_IDENTIFIER.ClutSlip': 'Prokluz spojky',
		'ENUM.CAN_IDENTIFIER.Cutter_Guide': 'Průvodce frézou',
		'ENUM.CAN_IDENTIFIER.Cutter_GuideP': 'Vedení frézy (P)',
		'ENUM.CAN_IDENTIFIER.Cutter_Pos': 'Poloha frézy',
		'ENUM.CAN_IDENTIFIER.Cutter_State': 'Fréza',
		'ENUM.CAN_IDENTIFIER.D1': 'Digitální 1',
		'ENUM.CAN_IDENTIFIER.D2': 'Digitální 2',
		'ENUM.CAN_IDENTIFIER.D3': 'Digitální 3',
		'ENUM.CAN_IDENTIFIER.D4': 'Digital 4',
		'ENUM.CAN_IDENTIFIER.Driv_Lever': 'Řídicí páka',
		'ENUM.CAN_IDENTIFIER.ENG_ABLev': 'Hladina AdBlue',
		'ENUM.CAN_IDENTIFIER.ENG_FueLev': 'Hladina paliva',
		'ENUM.CAN_IDENTIFIER.ENG_FueRat': 'Dávka paliva',
		'ENUM.CAN_IDENTIFIER.ENG_Spe': 'RPM',
		'ENUM.CAN_IDENTIFIER.ENG_Tor': 'Otáčky',
		'ENUM.CAN_IDENTIFIER.FHitch_Pos': 'Poloha závěsu vpředu',
		'ENUM.CAN_IDENTIFIER.FPTO_Eng': 'Přední vývodový hřídel aktivní',
		'ENUM.CAN_IDENTIFIER.FPTO_Spe': 'Rychlost PTO vpředu',
		'ENUM.CAN_IDENTIFIER.Field_Switch': 'Field_Switch',
		'ENUM.CAN_IDENTIFIER.Field_Switch2': ' Field_Switch2 ',
		'ENUM.CAN_IDENTIFIER.Front_Draft': 'Přední strana',
		'ENUM.CAN_IDENTIFIER.Front_NForce': 'Přední část (nominální)',
		'ENUM.CAN_IDENTIFIER.GB_Dir': 'Směr (pozemní)',
		'ENUM.CAN_IDENTIFIER.GB_Speed': 'Pozemní rychlost',
		'ENUM.CAN_IDENTIFIER.GPS_Speed': 'Rychlost GPS',
		'ENUM.CAN_IDENTIFIER.Gear_Sel': 'Vybraný rychlostní stupeň',
		'ENUM.CAN_IDENTIFIER.GrainCnv_Pos': 'Poloha dopravníku obilí',
		'ENUM.CAN_IDENTIFIER.GrainTnk_Lev': 'Hladina v nádrži na obilí',
		'ENUM.CAN_IDENTIFIER.HySt_Dir': ' HySt_Dir ',
		'ENUM.CAN_IDENTIFIER.HySt_Mod': ' HySt_Mod ',
		'ENUM.CAN_IDENTIFIER.Impl_Work': 'Implementace pracovního stavu',
		'ENUM.CAN_IDENTIFIER.JbSta': 'Práce aktivní',
		'ENUM.CAN_IDENTIFIER.Mot_L_Spe': 'Otáčky motoru (vlevo)',
		'ENUM.CAN_IDENTIFIER.Mot_L_Tor': 'Krouticí moment motoru (vlevo)',
		'ENUM.CAN_IDENTIFIER.Mot_R_Spe': 'Otáčky motoru (vpravo)',
		'ENUM.CAN_IDENTIFIER.Mot_R_Tor': 'Krouticí moment motoru (vpravo)',
		'ENUM.CAN_IDENTIFIER.NO_XTR': 'Žádná hodnota',
		'ENUM.CAN_IDENTIFIER.NUE_abs': 'SyreN: NUE absolute',
		'ENUM.CAN_IDENTIFIER.NUE_rel': 'SyreN: NUE relativní',
		'ENUM.CAN_IDENTIFIER.PHSlu': 'PH kejdy',
		'ENUM.CAN_IDENTIFIER.PTO_Switch': 'Přepínač PTO',
		'ENUM.CAN_IDENTIFIER.PTO_Switch1': 'Přepínač PTO 1',
		'ENUM.CAN_IDENTIFIER.PTO_Switch2': 'Přepínač PTO 2',
		'ENUM.CAN_IDENTIFIER.PTO_Switch3': 'PTO_Switch3',
		'ENUM.CAN_IDENTIFIER.PrxSen': 'Senzor přiblížení',
		'ENUM.CAN_IDENTIFIER.RHitch_Pos': 'Poloha závěsu vzadu',
		'ENUM.CAN_IDENTIFIER.RPTO_Eng': 'PTO vzadu aktivní',
		'ENUM.CAN_IDENTIFIER.RPTO_Spe': 'Rychlost PTO vzadu',
		'ENUM.CAN_IDENTIFIER.Rear_Draft': 'Zadní tah',
		'ENUM.CAN_IDENTIFIER.Rear_NForce': 'Ponor (nominální) zadní',
		'ENUM.CAN_IDENTIFIER.Roll': 'IO-Box: Rollrate',
		'ENUM.CAN_IDENTIFIER.Sli': 'Skluz',
		'ENUM.CAN_IDENTIFIER.Spe': 'Rychlost',
		'ENUM.CAN_IDENTIFIER.StrawChop_Pos': 'Poloha sekáčku slámy',
		'ENUM.CAN_IDENTIFIER.Thresh_Drum': 'Mlátička',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A1': 'Tlak v pneumatikách vlevo A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A2': 'Tlak v pneumatikách vlevo A2',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A1': 'správný tlak v pneumatikách A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A2': 'správný tlak v pneumatikách A2',
		'ENUM.CAN_IDENTIFIER.UnlAuger_Act': 'UnlAuger_Act ',
		'ENUM.CAN_IDENTIFIER.WB_Dir': 'Směr (na základě kola)',
		'ENUM.CAN_IDENTIFIER.WB_Speed': 'Rychlost na základě kola',
		'ENUM.CAN_IDENTIFIER.Xacc': 'Zrychlení X',
		'ENUM.CAN_IDENTIFIER.Yacc': 'Zrychlení Y',
		'ENUM.CAN_IDENTIFIER.Yaw': 'IO-Box: Yaw',
		'ENUM.CAN_IDENTIFIER.Yield_Act': 'Skutečný výnos',
		'ENUM.CAN_IDENTIFIER.Yield_Mois': 'Výnosová vlhkost',
		'ENUM.CAN_IDENTIFIER.Zacc': 'Zrychlení Z',
		'ENUM.COSTPER.h': 'h',
		'ENUM.COSTPER.ha': 'ha',
		'ENUM.COSTPER.km': 'km',
		'ENUM.COSTPER.l': 'l',
		'ENUM.CURRENCY.DOLLAR': '$',
		'ENUM.CURRENCY.EURO': '€',
		'ENUM.CURRENCY.GBP': '£',
		'ENUM.EMPLOYEEROLE.ADMIN': 'Admin',
		'ENUM.EMPLOYEEROLE.CONSULTANT': 'Konzultant',
		'ENUM.EMPLOYEEROLE.DISPONENT': 'Odesílatel',
		'ENUM.EMPLOYEEROLE.DRIVER': 'Řidič',
		'ENUM.EVENTTYPE.COMMENT': 'Zpráva',
		'ENUM.EVENTTYPE.CT': 'Počítadlo',
		'ENUM.EVENTTYPE.CT_RS': 'Reset počítadla',
		'ENUM.EVENTTYPE.CUSTOMER': 'Zákazník',
		'ENUM.EVENTTYPE.EMPL_C_IMPL': 'Zaměstnanec připojí nářadí',
		'ENUM.EVENTTYPE.EMPL_E_FIELD': 'Zaměstnanec vstupuje na pole',
		'ENUM.EVENTTYPE.EMPL_E_MACH': 'Zaměstnanec vstupuje do traktoru',
		'ENUM.EVENTTYPE.EMPL_L_FIELD': 'Zaměstnanec opouští pole',
		'ENUM.EVENTTYPE.EMPL_L_MACH': 'Zaměstnanec opouští traktor',
		'ENUM.EVENTTYPE.EMPL_P_START': 'Zaměstnanec začíná přestávku',
		'ENUM.EVENTTYPE.EMPL_P_STOP': 'Zaměstnanec končí přestávku',
		'ENUM.EVENTTYPE.EMPL_UC_IMPL': 'Zaměstnanec odpojí nářadí',
		'ENUM.EVENTTYPE.EMPL_W_START': 'Zaměstnanec začíná pracovat',
		'ENUM.EVENTTYPE.EMPL_W_STOP': 'Zaměstnanec dokončí práci',
		'ENUM.EVENTTYPE.GTO70': 'Obilný tank plný',
		'ENUM.EVENTTYPE.JOBINFO': 'Informace o práci',
		'ENUM.EVENTTYPE.JOB_PAUSE': 'Pauza',
		'ENUM.EVENTTYPE.JOB_RESUME': 'Pokračování práce',
		'ENUM.EVENTTYPE.JOB_START': 'Začátek práce',
		'ENUM.EVENTTYPE.JOB_STOP': 'Zastavení práce',
		'ENUM.EVENTTYPE.L_IMPL': 'Nářadí načteno',
		'ENUM.EVENTTYPE.REFUELING': 'Tankování',
		'ENUM.EVENTTYPE.SYREN_CUSTOMER': 'Zákazník společnosti SyreN',
		'ENUM.EVENTTYPE.SYREN_FIELD': 'Pole SyreN',
		'ENUM.EVENTTYPE.SYREN_SLURRY_TYPE': 'Typ kaše SyreN',
		'ENUM.EVENTTYPE.T2_ON': 'Adapter online',
		'ENUM.EVENTTYPE.UL_IMPL': 'Nářadí odpojeno',
		'ENUM.EVENTTYPE.WEATHER': 'Počasí',
		'ENUM.EVENTTYPE.WEIGHING': 'Vážení',
		'ENUM.EVENTTYPE.WEIGHING_TARA': 'Vážení (tára)',
		'ENUM.ISO_TASKDATA_STATE.CRE': 'Vytvořeno',
		'ENUM.ISO_TASKDATA_STATE.ONM': 'Na stroji',
		'ENUM.ISO_TASKDATA_STATE.RDY': 'Připraven',
		'ENUM.JOBGENERATIONSTATE.ARC': 'Archivováno',
		'ENUM.JOBGENERATIONSTATE.DEL': 'Mazání',
		'ENUM.JOBGENERATIONSTATE.EDT': 'Úpravy',
		'ENUM.JOBGENERATIONSTATE.GEN': 'Generování',
		'ENUM.JOBGENERATIONSTATE.MER': 'Sloučení',
		'ENUM.JOBGENERATIONSTATE.QUE': 'Ve frontě',
		'ENUM.JOBGENERATIONSTATE.READY': 'OK',
		'ENUM.JOBGENERATIONSTATE.REGEN': 'Regenerace',
		'ENUM.JOBGENERATIONSTATE.SPLT': 'Rozdělení',
		'ENUM.JOBGENERATIONSTATE.UPD': 'Aktualizace stránek',
		'ENUM.LOCATIONTYPE.FARM': 'Farma',
		'ENUM.LOCATIONTYPE.FUEL': 'Čerpací stanice',
		'ENUM.LOCATIONTYPE.OTHERS': 'Ostatní',
		'ENUM.LOCATIONTYPE.STABLE': 'Stáj',
		'ENUM.LOCATIONTYPE.WEIGHING': 'Měřítko',
		'ENUM.MACHINETYPE.COMBINE': 'Kombajn',
		'ENUM.MACHINETYPE.EXCAVATOR': 'Rypadlo',
		'ENUM.MACHINETYPE.FORAGE_HARVESTER': 'Sklízecí řezačka',
		'ENUM.MACHINETYPE.MISC': 'Ostatní',
		'ENUM.MACHINETYPE.SELF_PROPELLED': 'S vlastním pohonem',
		'ENUM.MACHINETYPE.SYREN': 'Syren',
		'ENUM.MACHINETYPE.TELEHANDLER': 'Teleskopický manipulátor',
		'ENUM.MACHINETYPE.TRACTOR': 'Traktor',
		'ENUM.MACHINETYPE.TRUCK': 'Kamion',
		'ENUM.MACHINETYPE.WHEELLOADER': 'Kolový nakladač',
		'ENUM.MSGUNIT.-': '-',
		'ENUM.MSGUNIT.AXLES': 'Nápravy',
		'ENUM.MSGUNIT.CUBIC_M': 'm³',
		'ENUM.MSGUNIT.DOLLAR': '$',
		'ENUM.MSGUNIT.EURO': '€',
		'ENUM.MSGUNIT.KG': 'kg',
		'ENUM.MSGUNIT.LITER': 'l',
		'ENUM.MSGUNIT.TONS': 't',
		'ENUM.MSGUNIT.h': 'h',
		'ENUM.MSGUNIT.ha': 'ha',
		'ENUM.MSGUNIT.km': 'km',
		'ENUM.ONLY_ON_STATE.A': 'Vždy',
		'ENUM.ONLY_ON_STATE.F': 'Pole',
		'ENUM.ONLY_ON_STATE.L': 'Město',
		'ENUM.ONLY_ON_STATE.R': 'Silnice',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_1200': 'AgLeader InCommand 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_800': 'AgLeader InCommand 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INTEGRA': 'AgLeader Integra',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_VERSA': 'AgLeader Versa',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD': 'Amazone Amapad',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD_2': 'Amazone Amapad 2',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_3': 'Amazone Amatron 3',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_4': 'Amazone Amatron 4',
		'ENUM.TRACTOR_TERMINAL_TYPE.AN_L10I': 'Andeo L10i',
		'ENUM.TRACTOR_TERMINAL_TYPE.A_XY': 'A_XY',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_1200': 'Case AFS Pro 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_700': 'Case AFS Pro 700',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_1200': 'CCI 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_800': 'CCI 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_CEMIS_1200': 'Claas Cemis 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S10': 'Claas S10',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S7': 'Claas S7',
		'ENUM.TRACTOR_TERMINAL_TYPE.C_S2034': 'C_S2034',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_ONE': 'Fendt One',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_VARIOTERMINAL_10_4': 'Fendt Varioterminal 10.4',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_2630': 'John Deere 2630',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_GEN4': 'John Deere Gen4',
		'ENUM.TRACTOR_TERMINAL_TYPE.KV_TELLUS': 'Kverneland Tellus',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME': 'Müller Elektronik Basic',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_COMFORT': 'Müller Elektronik Comfort',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_1200': 'Müller Elektronik Touch 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_800': 'Müller Elektronik Touch 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.MF_DATATRONIC_5': 'MF Datatronic 5',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR12': 'Raven CR12',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR7': 'Raven CR7',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_VIPER4': 'Raven Viper4',
		'ENUM.TRACTOR_TERMINAL_TYPE.RH_SMART_COMMAND': 'Reichhardt Smart Command',
		'ENUM.TRACTOR_TERMINAL_TYPE.SDF_IMONITOR3': 'SDF iMonitor3',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X25': 'Topcon x25',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X30': 'Topcon x30',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X35': 'Topcon x35',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_XD': 'Topcon XD',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_1260': 'Trimble GFX 1260',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_750': 'Trimble GFX 750',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_TMX_2050': 'Trimble TMX 2050',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_1': 'Typ 1 (zapisuje na USB flash disk)',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_2': 'Typ 2 (nezapisuje na USB disk)',
		'ENUM.TRANSPORTUNIT.-': '-',
		'ENUM.TRANSPORTUNIT.AXLES': 'Nápravy',
		'ENUM.TRANSPORTUNIT.BALE': 'Balík',
		'ENUM.TRANSPORTUNIT.CUBIC_M': 'm³',
		'ENUM.TRANSPORTUNIT.KG': 'kg',
		'ENUM.TRANSPORTUNIT.LITER': 'l',
		'ENUM.TRANSPORTUNIT.TONS': 't',
		'ENUM.USERROLE.ADMIN': 'Admin',
		'ENUM.USERROLE.ENTERPRISE': 'Podnik',
		'ENUM.USERROLE.SALES_FORCE_TECH': 'Tech. Salesforce',
		'ENUM.USERROLE.TRAN': 'Překlad',
		'ENUM.USERROLE.USER': 'Uživatel',
		'ENUM.USERROLE.USER_EMPL': 'Uživatel (podnik)',
		'ENUM.USERSTATE.ACTIVE': 'Aktivní',
		'ENUM.USERSTATE.DISABLED': 'Zakázáno',
		'ENUM.USERSTATE.NOT_VERIFIED': 'Neověřeno',
		'ENUM.WORKSTATE.DRIVING': 'Řízení',
		'ENUM.WORKSTATE.DRIVING_MISC': 'Řízení - čekání',
		'ENUM.WORKSTATE.MISC_FIELD': 'Pole - čekání',
		'ENUM.WORKSTATE.MISC_FIELD_GTF': 'Plná nádrž na obilí',
		'ENUM.WORKSTATE.MISC_ROAD': 'Silnice - čekání',
		'ENUM.WORKSTATE.PAUSE': 'Pauza',
		'ENUM.WORKSTATE.PREPARATION': 'Příprava',
		'ENUM.WORKSTATE.ROAD': 'Silnice',
		'ENUM.WORKSTATE.THRESHING': 'Mlátit',
		'ENUM.WORKSTATE.THRESHING_U': 'Vykládání při mlácení',
		'ENUM.WORKSTATE.THRESHING_W_SC': 'Mlácení se slámou',
		'ENUM.WORKSTATE.THRESHING_W_SC_U': 'Vykládka při mlácení slámy',
		'ENUM.WORKSTATE.TRANSPORT_LOADED': 'Nakládka',
		'ENUM.WORKSTATE.TRANSPORT_LOADED_MISC': 'Nakládka - čekání',
		'ENUM.WORKSTATE.TRANSPORT_LOADING': 'Nakládání ',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED': 'Vykládka',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED_MISC': 'Vykládka - čekání ',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING': 'Vykládání',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING_DRIV': 'Vykládka za jízdy',
		'ENUM.WORKSTATE.TURNING': 'Otáčení',
		'ENUM.WORKSTATE.UNDEFINED': 'Nedefinováno',
		'ENUM.WORKSTATE.WORKING': 'Pracovní',
		'ENUM.WORKSTATE.WORKING_MISC': 'Práce - čekání',
		'ERROR.NO_GPS_DATA': 'Pro vybraný stroj nejsou k dispozici žádná GPS data',
		'ERROR_MESSAGE': 'Chybové hlášení',
		'EVENTS': 'Události',
		'EVENTS.FIELD': 'Události na poli',
		'EVENTS.NO': 'Žádné události',
		'EXA_ADAPTERS': 'Adaptér',
		'EXA_ADAPTERS.AR_ACTIVATE': 'Aktivujte adaptér v Agrirouteru',
		'EXA_ADAPTERS.AR_DEACTIVATE': 'Odstraňte adaptér v Agrirouteru',
		'EXA_ADAPTERS.AR_LINK_SUCCESS': 'Adaptér aktivován v Agrirouteru',
		'EXA_ADAPTERS.AR_UNLINK_SUCCESS': 'Adaptér odstraněn z Agrirouteru',
		'EXCEPTION.1': 'Interní chyba',
		'EXCEPTION.100': 'Výčet neplatný',
		'EXCEPTION.1000': 'Uživatelské jméno je prázdné',
		'EXCEPTION.10000': 'Název souboru je prázdný',
		'EXCEPTION.10001': 'Data jsou prázdná',
		'EXCEPTION.10002': 'Typ formátu je neplatný',
		'EXCEPTION.10003': 'Typ požadavku na data je neplatný',
		'EXCEPTION.10004': 'Žádná nezpracovaná data',
		'EXCEPTION.1001': 'Délka uživatelského jména je kratší než minimální délka',
		'EXCEPTION.1002': 'Uživatelské jméno je již zabrané',
		'EXCEPTION.1003': 'E -mailová adresa je neplatná',
		'EXCEPTION.1004': 'E -mailová adresa je již použitá',
		'EXCEPTION.1005': 'Délka hesla je kratší než minimální délka',
		'EXCEPTION.1007': 'Ověřovací kód je neplatný',
		'EXCEPTION.1008': 'Uživatelské jméno (nebo e -mailová adresa) je neplatné',
		'EXCEPTION.101': 'Role zaměstnance je neplatná',
		'EXCEPTION.1011': 'Uživatel neexistuje',
		'EXCEPTION.1012': 'Uživatel je smazán',
		'EXCEPTION.1013': 'Uživatel je neaktivní',
		'EXCEPTION.1014': 'Uživatel je zablokován',
		'EXCEPTION.1015': 'Uživatel není aktivován',
		'EXCEPTION.1016': 'Uživatel je podnikový účet',
		'EXCEPTION.102': 'Měna je neplatná',
		'EXCEPTION.1020': 'Uživatel již existuje',
		'EXCEPTION.1021': 'E -mailová adresa je již použita',
		'EXCEPTION.1022': 'E -mailová adresa se nezměnila',
		'EXCEPTION.1023': 'Aktuální heslo se neshoduje',
		'EXCEPTION.1024': 'Uživatelské jméno je již zabrané',
		'EXCEPTION.1025': 'Uživatel a kód se neshodují',
		'EXCEPTION.1026': 'Uživatelské jméno (nebo e -mailová adresa) je neplatné',
		'EXCEPTION.1027': 'Uživatel je již aktivován',
		'EXCEPTION.1028': 'Zakázáno pro zaměstnanecké účty vytvořené pro podnik',
		'EXCEPTION.103': 'Transportní jednotka je neplatná',
		'EXCEPTION.104': 'Typ umístění je neplatný',
		'EXCEPTION.105': 'Nákladová jednotka je neplatná',
		'EXCEPTION.106': 'Jednotka je neplatná',
		'EXCEPTION.107': 'Typ stroje je neplatný',
		'EXCEPTION.108': 'Stav zaměstnance neplatný',
		'EXCEPTION.11000': 'Typ neplatný',
		'EXCEPTION.12000': 'Typ neplatný',
		'EXCEPTION.12002': 'Sériové číslo je prázdné',
		'EXCEPTION.12003': 'Stav práce je neplatný',
		'EXCEPTION.12004': 'Stav úlohy je neplatný',
		'EXCEPTION.12006': 'Žádná konfigurace T2',
		'EXCEPTION.12007': 'MAC je prázdný',
		'EXCEPTION.12008': 'MAC je neplatný',
		'EXCEPTION.12009': 'Adaptér již existuje',
		'EXCEPTION.12010': 'Typ adaptéru je neplatný',
		'EXCEPTION.15000': 'Čas zahájení je prázdný nebo v budoucnosti',
		'EXCEPTION.15001': 'Čas zastavení je prázdný nebo v budoucnosti',
		'EXCEPTION.15002': 'Čas zastavení je stejný nebo se nachází před  začátkem',
		'EXCEPTION.15003': 'Nelze vygenerovat balíček SILO - žádná nezpracovaná data',
		'EXCEPTION.15004': 'Nezpracovaná data jsou příliš stará',
		'EXCEPTION.16000': 'Jméno je prázdné',
		'EXCEPTION.16001': 'Přiřazený zákazník neexistuje',
		'EXCEPTION.16002': 'Seznam značek je prázdný',
		'EXCEPTION.16003': 'Popis značek musí obsahovat alespoň tři znaky',
		'EXCEPTION.16004': 'Oblast je prázdná',
		'EXCEPTION.16005': 'Typ značky je neplatný',
		'EXCEPTION.16006': 'Pole není obsaženo v úloze',
		'EXCEPTION.16007': 'Velikost mřížky je větší než polovina výšky a šířky pole',
		'EXCEPTION.16008': 'Žádná data k interpolaci',
		'EXCEPTION.16009': 'Všechna data obsahují stejnou hodnotu',
		'EXCEPTION.17000': 'Jméno je prázdné',
		'EXCEPTION.17001': 'Kontaktní osoba je prázdná',
		'EXCEPTION.17002': 'Telefon není zadaný',
		'EXCEPTION.17003': 'E -mailová adresa je prázdná',
		'EXCEPTION.17004': 'E -mailová adresa je neplatná',
		'EXCEPTION.17005': 'Adresa je prázdná',
		'EXCEPTION.17006': 'PSČ je prázdné',
		'EXCEPTION.17007': 'Město je prázdné',
		'EXCEPTION.17008': 'Neplatná barva ((AA) RRGGBB)',
		'EXCEPTION.18000': 'Typ neplatný',
		'EXCEPTION.19001': 'Typ neplatný',
		'EXCEPTION.19002': 'MAC je prázdný',
		'EXCEPTION.19003': 'MAC je neplatný',
		'EXCEPTION.19004': 'Výkon je menší než nula',
		'EXCEPTION.19007': 'Zaměstnanec je prázdný',
		'EXCEPTION.19008': 'Čip není čipem nářadí',
		'EXCEPTION.19009': 'Čip není čipem řidiče',
		'EXCEPTION.2': 'Duplicitní záznam',
		'EXCEPTION.200': 'Chyba při analýze typu objektu JSON',
		'EXCEPTION.2000': 'Vytvoření ověřovacího kódu se nezdařilo',
		'EXCEPTION.20000': 'Množství nezpracovaných dat je příliš nízké',
		'EXCEPTION.20001': 'Vytvoření archivního souboru se nezdařilo',
		'EXCEPTION.20002': 'Načtení archivního souboru se nezdařilo',
		'EXCEPTION.2001': 'Ověřovací kód neexistuje',
		'EXCEPTION.2002': 'Ověřovací kód je neplatný',
		'EXCEPTION.201': 'Chyba při zápisu typu objektu do JSON',
		'EXCEPTION.21000': 'Název podniku je prázdný',
		'EXCEPTION.21001': 'Název podniku již byl použit',
		'EXCEPTION.21002': 'Délka názvu podniku je kratší než minimální délka',
		'EXCEPTION.21003': 'E -mailová adresa podniku je neplatná',
		'EXCEPTION.21004': 'Přístupový token již existuje',
		'EXCEPTION.21005': 'Podnik je vymazán',
		'EXCEPTION.21006': 'Podnik je deaktivována',
		'EXCEPTION.21007': 'Podnik je blokována',
		'EXCEPTION.21008': 'Typ podniku je neplatný',
		'EXCEPTION.22000': 'Žádné úlohy k přidání',
		'EXCEPTION.22001': 'Nebyly změněné  žádné úlohy',
		'EXCEPTION.23000': 'Podnik není připojen',
		'EXCEPTION.23001': 'Podnik  je již připojen',
		'EXCEPTION.23002': 'Adaptér není připojen',
		'EXCEPTION.23003': 'Adaptér je již připojen',
		'EXCEPTION.23004': 'Nelze připojit adaptér',
		'EXCEPTION.23005': 'Adaptér se nepodařilo znovu připojit',
		'EXCEPTION.23006': 'Nelze připojit adaptér',
		'EXCEPTION.23007': 'Publikování v CU se nezdařilo',
		'EXCEPTION.23008': 'Publikování dat v CU se nezdařilo',
		'EXCEPTION.23009': 'Publikování popisu zařízení vCU se nezdařilo',
		'EXCEPTION.23010': 'Publikování podnikových funkcí se nezdařilo',
		'EXCEPTION.23011': 'Chyba certifikátu Agrirouter! Obnovili jste připojení Agrirouter?',
		'EXCEPTION.24000': 'Název podniku je prázdný',
		'EXCEPTION.24001': 'Název podniku již byl použit',
		'EXCEPTION.24002': 'Délka názvu podniku je kratší než minimální délka',
		'EXCEPTION.24003': 'E -mailová adresa podniku je neplatná',
		'EXCEPTION.24004': 'Přístupový token již existuje',
		'EXCEPTION.24005': 'Podnik je vymazán',
		'EXCEPTION.24006': 'Podnik je deaktivován',
		'EXCEPTION.24007': 'Podnik je blokován',
		'EXCEPTION.25000': 'Funkce není k dispozici pro vybraného partnera',
		'EXCEPTION.25001': 'Synchronizace polí se nezdařila',
		'EXCEPTION.25002': 'Synchronizace strojů se nezdařila',
		'EXCEPTION.25003': 'Synchronizace nářadí se nezdařila',
		'EXCEPTION.25004': 'Získání stroje se nezdařilo',
		'EXCEPTION.25005': 'Vytvoření stroje se nezdařilo',
		'EXCEPTION.25006': 'Aktualizace stroje se nezdařila',
		'EXCEPTION.25007': 'Vymazání stroje se nezdařilo',
		'EXCEPTION.25008': 'Získání nářadí se nezdařilo',
		'EXCEPTION.25009': 'Vytvoření nářadí se nezdařilo',
		'EXCEPTION.25010': 'Aktualizace nářadí se nezdařila',
		'EXCEPTION.25011': 'Odstranění nářadí se nezdařilo',
		'EXCEPTION.26000': 'Vytvoření souboru PDF se nezdařilo',
		'EXCEPTION.26001': 'Vybraná úloha není žádná úloha podporující SyreN',
		'EXCEPTION.27000': 'Zařízení nepodporuje soubory TaskData',
		'EXCEPTION.27001': 'Vytvoření souboru TaskData se nezdařilo',
		'EXCEPTION.27002': 'Načtení souboru TaskData se nezdařilo',
		'EXCEPTION.27003': 'Stroj nemá přiřazený adaptér',
		'EXCEPTION.27004': 'Jméno je prázdné',
		'EXCEPTION.27005': 'Plánované datum je prázdné',
		'EXCEPTION.27006': 'Plánované datum není v budoucnosti',
		'EXCEPTION.27007': 'Stát je prázdný',
		'EXCEPTION.27008': 'Soubor je prázdný',
		'EXCEPTION.27009': 'Název souboru je prázdný',
		'EXCEPTION.27010': 'Datum je prázdné',
		'EXCEPTION.27011': 'Datum není v budoucnosti',
		'EXCEPTION.27012': 'Velikost je nižší než jedna',
		'EXCEPTION.27013': 'Operace TaskData není v aktuálním stavu k dispozici',
		'EXCEPTION.27014': 'Název souboru již byl převzat',
		'EXCEPTION.27015': 'Žádné otevřené úkoly',
		'EXCEPTION.27016': 'Povolen je pouze jeden nestažený soubor TaskData',
		'EXCEPTION.28001': 'Typ souboru není podporován',
		'EXCEPTION.29000': 'Aktualizace není povolena (již zpracováno)',
		'EXCEPTION.29001': 'Není uveden žádný stroj ani nářadí',
		'EXCEPTION.29002': 'Povolen pouze stroj NEBO nářadí',
		'EXCEPTION.29003': 'Základní hodnota musí být větší než nula',
		'EXCEPTION.29004': 'Hodnota varování musí být větší než nula',
		'EXCEPTION.29005': 'Splatná hodnota musí být větší než nula',
		'EXCEPTION.29006': 'Interval splatnosti musí být větší než interval varování',
		'EXCEPTION.3000': 'Přihlašovací údaje jsou neplatné',
		'EXCEPTION.3001': 'Účet je zablokován',
		'EXCEPTION.3002': 'Účet není aktivován',
		'EXCEPTION.3003': 'Platnost připojení vypršelo - Přihlaste se prosím znovu',
		'EXCEPTION.3004': 'Se stejným účtem se přihlásil další uživatel',
		'EXCEPTION.31000': 'Aplikace není podporována',
		'EXCEPTION.4000': 'Značka je prázdná',
		'EXCEPTION.4001': 'Model je prázdný',
		'EXCEPTION.4002': 'Rok musí být větší než 1950 a ne v budoucnosti',
		'EXCEPTION.4003': 'Cena je menší nebo rovna nule',
		'EXCEPTION.4004': 'Provozní hodiny jsou nižší než nula',
		'EXCEPTION.4005': 'Kilometry jsou menší než nula',
		'EXCEPTION.4007': 'Pracovní šířka je menší než nula',
		'EXCEPTION.4008': 'Neplatná barva ((AA) RRGGBB',
		'EXCEPTION.4009': 'Konfigurace hodnot XtrCan je neplatná',
		'EXCEPTION.401': 'Neoprávněný',
		'EXCEPTION.4010': 'Příliš mnoho konfiguračních hodnot',
		'EXCEPTION.4011': 'Dynamická konfigurace je neplatná',
		'EXCEPTION.4012': 'Typ stroje není traktor',
		'EXCEPTION.4013': 'Je odebrán maximální počet licencí',
		'EXCEPTION.4014': 'Datum je v budoucnosti',
		'EXCEPTION.4015': 'Přepsání rychlosti je neplatné',
		'EXCEPTION.403': 'Zakázáno',
		'EXCEPTION.450': 'Chyba příkazu',
		'EXCEPTION.451': 'Žádná požadovaná licence',
		'EXCEPTION.452': 'Parametr filtru je neplatný',
		'EXCEPTION.5000': 'Značka je prázdná',
		'EXCEPTION.5001': 'Model je prázdný',
		'EXCEPTION.5002': 'Rok musí být vyšší než 1950 a ne v budoucnosti',
		'EXCEPTION.5003': 'Typ1 je prázdný',
		'EXCEPTION.5004': 'Typ 2 je neplatný',
		'EXCEPTION.5005': 'Náklady jsou nižší nebo rovny nule',
		'EXCEPTION.5006': 'Pracovní šířka je menší než nula',
		'EXCEPTION.5007': 'Transportní hodnota je menší než nula',
		'EXCEPTION.5008': 'Transportní jednotka je neplatná',
		'EXCEPTION.5009': 'Typ 3 je neplatný',
		'EXCEPTION.5010': 'Kombinace typů je neplatná',
		'EXCEPTION.5011': 'Účetní identifikátor je neplatný',
		'EXCEPTION.6000': 'Typ neplatný',
		'EXCEPTION.6001': 'Rádius je prázdný nebo pod nulou',
		'EXCEPTION.6002': 'Jméno je prázdné',
		'EXCEPTION.6003': 'Seznam značek je prázdný',
		'EXCEPTION.6004': 'Seznam popisek  musí obsahovat alespoň tři znaky',
		'EXCEPTION.6005': 'Marker type invalid',
		'EXCEPTION.6006': 'Typ vážení je neplatný',
		'EXCEPTION.700': 'Název proměnné je neplatný',
		'EXCEPTION.7001': 'Účet neexistuje',
		'EXCEPTION.7002': 'Účet je zablokován',
		'EXCEPTION.701': 'Vzorec je neplatný',
		'EXCEPTION.702': 'Název CANId je neplatný',
		'EXCEPTION.703': 'Stav neplatný',
		'EXCEPTION.704': 'Název proměnné je neplatný',
		'EXCEPTION.705': 'Parametr pracovní stanice je neplatný',
		'EXCEPTION.706': 'Pracovní aktivita není platná pro nářadí',
		'EXCEPTION.707': 'Vytvoření souboru se nezdařilo',
		'EXCEPTION.800': 'Název hodnoty ConfigValue je neplatný',
		'EXCEPTION.8000': 'Zaměstnavatel je prázdný',
		'EXCEPTION.8001': 'Zaměstnanec je prázdný',
		'EXCEPTION.8002': 'Zaměstnanec nebyl nalezen pro zaměstnavatele',
		'EXCEPTION.8003': 'Náklady nižší než nula',
		'EXCEPTION.8004': 'Maximální počet přijatých uživatelských licencí',
		'EXCEPTION.8005': 'Ne váš zaměstnavatel',
		'EXCEPTION.8006': 'Zaměstnanec již existuje',
		'EXCEPTION.8007': 'Přístupový token je prázdný',
		'EXCEPTION.8008': 'Přístupový token je neplatný',
		'EXCEPTION.8009': 'V podniku musí existovat alespoň jeden správce',
		'EXCEPTION.8010': 'Uživatele lze připojit pouze k podniku, který jej vytvořil',
		'EXCEPTION.900': 'Neexistuje',
		'EXCEPTION.9000': 'Čas není vyplněn nebo je budoucnosti',
		'EXCEPTION.9001': 'Čas zastavení není vyplněn nebo v budoucnosti',
		'EXCEPTION.9002': 'Čas zastavení je stejný nebo menší než čas začátku',
		'EXCEPTION.9003': 'Řidič není zaměstnancem vlastníka úlohy',
		'EXCEPTION.9004': 'Implement  nepatří vlastníkovi úlohy',
		'EXCEPTION.9005': 'Typ 1 je neplatný',
		'EXCEPTION.9006': 'Typ 2 je neplatný',
		'EXCEPTION.9007': 'Typ 3 je neplatný',
		'EXCEPTION.9008': 'Nelze vygenerovat úlohu - žádná nezpracovaná data',
		'EXCEPTION.9009': 'Vlastník stroje neodpovídá majiteli nářadí',
		'EXCEPTION.901': 'Již existuje',
		'EXCEPTION.9010': 'ˇuloha již existuje',
		'EXCEPTION.9012': 'Úloha není připravena',
		'EXCEPTION.9013': 'Úloha je označena k odstranění',
		'EXCEPTION.9014': 'Úloha je archivována - není k dispozici žádná pracovní pozice',
		'EXCEPTION.9015': 'Nezpracovaná data jsou příliš stará',
		'EXCEPTION.9016': 'Součástí zadání je alespoň jedna úloha ',
		'EXCEPTION.9017': 'Úlohy se neshodují (stroj, ovladač, nářadí se musí shodovat)',
		'EXCEPTION.9018': 'Rozdíl mezi úlohami je příliš velký',
		'EXCEPTION.9019': 'Součástí zadání je alespoň jedna úloha',
		'EXCEPTION.902': 'Vlastník neexistuje',
		'EXCEPTION.9020': 'Žádné mezičasy',
		'EXCEPTION.9021': 'Čas rozdělení není delší než čas začátku a kratší než čas zastavení',
		'EXCEPTION.9022': 'Žádné ID úlohy pro sloučení',
		'EXCEPTION.9023': 'Jsou vyžadovány alespoň dvě ulohy',
		'EXCEPTION.9024': 'Hustota bodů musí být větší nula a menší nebo rovna jedné',
		'EXCEPTION.903': 'Objekt s ID neexistuje',
		'EXCEPTION.904': 'Zeměpisná šířka je mimo rozsah',
		'EXCEPTION.905': 'Zeměpisná délka je mimo rozsah',
		'EXCEPTION.906': 'Vlastník se neshoduje',
		'EXCEPTION.907': 'Parametr je prázdný',
		'EXCEPTION.99': 'Parametr je neplatný',
		'EXPORT': 'Export',
		'EXPORT.FILTERED_JOBS': 'Exportovat všechny filtrované úlohy',
		'EXPORT.JOB_DETAILS': 'Exportovat podrobnosti úlohy',
		'EXPORT.OPERATIONS.CUSTOMER.PERIOD': 'Exportovat všechna data pro zákazníka ve vybraném období',
		'EXPORT.OPERATIONS.FIELDS.PERIOD': 'Export všech operací s poli ve vybraném období',
		'EXPORT.OPERATIONS.LOCATIONS.PERIOD': 'Export všech operací na místech ve vybraném období',
		'EXPORT.POINTS': 'Datové body',
		'EXPORT.POLYGONS': 'Polygony',
		'EXPORT.RAW_DATA_AS_SILO': 'Exportujte nezpracovaná data úlohy jako soubor SILO',
		'EXPORT.SELECTED': 'Vybraný export',
		'EXPORT.SELECT_DATA': 'Vyberte prosím data, která budou zahrnuta do zprávy PDF',
		'EXPORT.SELECT_PERIOD': 'Vyberte období pro export:',
		'FIELD': 'Pole',
		'FIELD.ADD': 'Přidat pole',
		'FIELD.ADD.SUCCESS': 'Pole bylo úspěšně přidáno',
		'FIELD.DEACTIVATE.QUESTION': 'Opravdu chcete pole deaktivovat?',
		'FIELD.DEACTIVATE.SUCCESS': 'Pole bylo úspěšně deaktivováno',
		'FIELD.DELETE.QUESTION': 'Opravdu chcete pole smazat?',
		'FIELD.DELETE.SUCCESS': 'Pole úspěšně smazáno',
		'FIELD.DETAILS': 'Podrobnosti pole',
		'FIELD.DRAW.START': 'Nakreslete hranice polí do mapy!',
		'FIELD.EDIT.SUCCESS': 'Pole bylo úspěšně upraveno',
		'FIELD.INTERPOLATE': 'Interpolovat',
		'FIELD.INTERPOLATED_VALUES': 'Interpolované hodnoty',
		'FIELD.INTERPOLATION': 'Interpolace',
		'FIELD.INTERPOLATION_SETTINGS': 'Nastavení interpolace',
		'FIELD.INTERPOLATION_SETTINGS.FINE': 'Pokuta',
		'FIELD.INTERPOLATION_SETTINGS.FINE+': 'Velmi jemné',
		'FIELD.INTERPOLATION_SETTINGS.ROUGH': 'Hrubý',
		'FIELD.INTERPOLATION_SETTINGS.STANDARD': 'Standard',
		'FIELD.NUMBER': 'Číslo pole',
		'FIELD.PROCESSED': 'Zpracované pole',
		'FIELDS': 'Pole',
		'FIELDS.ALL': 'Všechna pole',
		'FIELDS.DEACTIVATE.FAILURE': 'Některá pole nebylo možné deaktivovat.',
		'FIELDS.DEACTIVATE.QUESTION': 'Opravdu chcete pole deaktivovat?',
		'FIELDS.DEACTIVATE.SUCCESS': 'Pole byla úspěšně deaktivována',
		'FIELDS.DELETE.FAILURE': 'Některá pole se nepodařilo smazat.',
		'FIELDS.DELETE.QUESTION': 'Opravdu chcete smazat vybraná pole?',
		'FIELDS.DELETE.SUCCESS': 'Pole byla úspěšně smazána',
		'FIELDS.EDIT': 'Upravit pole',
		'FIELDS.IMPORT': 'Import Pole',
		'FIELDS.IMPORT.ASSIGN_CUSTOMER.QUESTION': 'Chcete k vybraným polím přiřadit zákazníka?',
		'FIELDS.IMPORT.SHAPE': 'Vyberte soubor SHAPE, který chcete importovat.',
		'FIELDS.IMPORT.SUCCESS': 'Úspěšně importovaná pole',
		'FIELDS.MANAGEMENT': 'Správa Pole',
		'FIELDS.NO': 'Žádná pole',
		'FIELDS.NOT_SELECTED': 'Nejsou vybrána žádná pole',
		'FIELDS.REACTIVATE.FAILURE': 'Některá pole nebylo možné znovu aktivovat.',
		'FIELDS.REACTIVATE.QUESTION': 'Opravdu chcete vybraná pole znovu aktivovat?',
		'FIELDS.REACTIVATE.SUCCESS': 'Pole byla úspěšně reaktivována',
		'FIELDS.SELECT': 'Vyberte Pole',
		'FIELDS.SELECTED': 'Vybraná Pole',
		'FILE': 'Soubor',
		'FILE.GENERATING': 'Soubor se vygeneruje a brzy bude přidán do správce souborů.',
		'FILE.GENERATING.READY': 'Nový soubor je připraven ke stažení',
		'FILE.MANAGER': 'Správce souborů',
		'FILE.NO_FILES': 'Žádné existující soubory',
		'FILE.UPLOAD': 'Nahrát soubor',
		'FILE_TRANSFER': 'Správa dat ISOTaskData',
		'FILE_TRANSFER.ADD': 'Přidat ISOTaskData',
		'FILE_TRANSFER.ADD.SUCCESS': 'ISOTaskData úspěšně přidána',
		'FILE_TRANSFER.CREATE': 'Přidat ISOTaskData',
		'FILE_TRANSFER.DELETE.QUESTION': 'Opravdu chcete odstranit ISOTaskData?',
		'FILE_TRANSFER.DELETE.SUCCESS': 'ISOTaskData úspěšně odstraněna',
		'FILE_TRANSFER.FINISHED_TASKS': 'Připravené úkoly',
		'FILE_TRANSFER.NO': 'Ne ISOTaskData',
		'FILE_TRANSFER.QUEUED_TASKS': 'Úlohy ve frontě',
		'FILTER': 'Filtr',
		'FIRMWARE_VERSION': 'Verze firmwaru',
		'FIRSTNAME': 'Jméno',
		'FORMS.FILE_TOO_LARGE': 'Soubor je příliš velký.',
		'FORMS.NO_PASSWORD_MATCH': 'Hesla se neshodují!',
		'FORMS.REQUIRED': 'Požadované',
    'FORMS.INVALID_EMAIL': 'Neplatní e-mailová adresa.',
		'FORMULA': 'Vzorec',
		'FUEL': 'Pohonné hmoty',
		'FUEL.CONSUMPTION': 'Spotřeba paliva',
		'FUEL.CONSUMPTION.AREA': 'Spotřeba paliva na plochu',
		'FUEL.CONSUMPTION.AVERAGE': 'Průměrná spotřeba paliva',
		'FUEL.CONSUMPTION.OVERALL': 'Celková spotřeba paliva',
		'FUEL.CONSUMPTION.TOTAL': 'Celková spotřeba paliva',
		'FUEL.COST': 'Cena paliva',
		'FUEL.LEVEL': 'Hladina paliva',
		'FUEL.PRICE_PER_LITER': 'Cena paliva za litr',
		'FUEL.WARNING': 'Nízká hladina paliva!',
		'GENERAL_INSPECTION': 'Obecná kontrola',
		'GEOMETRIES.UPDATE': 'Aktualizace polí a místa',
		'GEOMETRY.ADD.REGENERATION_NEEDED': 'Po přidání nové geometrie je třeba aktualizovat všechna podkladová data, aby byla správně přiřazena. Chcete data aktualizovat nyní?',
		'GEOMETRY.CLICK_TO_SAVE': 'Pro uložení klikněte na mapa.',
		'GPS': 'GPS',
		'GPS.GPS': 'Interní GPS',
		'GPS.LP': 'Poslední známá pozice',
		'GPS.RTK': 'RTK',
		'GPS.RTK_H': 'RTK (vysoká přesnost)',
		'GPS.STATUS': 'Stav GPS',
		'GPS_HITCH_DISTANCE.IMPLEMENT.INFO': 'For recording the machine track correctly you need to input the distance between the hitch (A) and the point of application of the implement (B). The distance is measured in cm.',
		'GPS_HITCH_DISTANCE.MACHINE.INFO': 'For recording the machine track correctly you need to input the distance between the GPS receiver (A) and the hitch of the machine (B). The distance is measured in cm.',
		'GPS_TO_HITCH_DISTANCE': 'Vzdálenost mezi GPS a závěsem',
		'HARDWARE': 'Adaptéry a čipy',
		'HARDWARE.SETUP.PRINT_STICKER': 'Tisk hardwarové nálepky',
		'HARDWARE.SETUP.PRINT_STICKER_PACKAGING': 'Tisk nálepky na obalu',
		'HARDWARE.SETUP.RESET_DEVICE': 'Resetování zařízení',
		'HARDWARE.SETUP.SET_SERIAL': 'Nastavení sériového',
		'HEADLAND.PASSES': 'Headland passes',
		'HELPER_MODEL_TEXT': 'Model podle vstupu',
		'HINT_MARKERS.SHOW': 'Zobrazit značky s nápovědou',
		'HITCH_TO_APPLICATION_DISTANCE': 'Vzdálenost mezi závěsem a aplikací',
		'HOME': 'Vítejte',
		'HOME.CONTACTREPLY1': 'Pak nám neváhejte zavolat na',
		'HOME.CONTACTREPLY2': 'nebo nám pošlete e-mail na',
		'HOME.INTRODUCTORY_VIDEOS': 'Úvodní videa',
		'HOME.NEWSINFO1': 'Všechny novinky a zajímavé informace o správě vozového parku a sledování strojů najdete na našem webu',
		'HOME.NEWSINFO2': 'nebo na našem',
		'HOME.PROFILEEXPLANATION': 'V části „Můj profil“ můžete změnit své osobní údaje, svůj e-mail a heslo.',
		'HOME.QUESTIONSYSTEM': 'Máte nějaké dotazy k našemu systému?',
		'HOME.TITLE': 'Vítejte',
		'HOME.WELCOMEAREA': 'Vítejte ve své oblasti!',
		'IDLE': 'Nečinný',
		'IGNORE': 'Ignorovat',
		'IMPLEMENT': 'Nářadí',
		'IMPLEMENT.ADD': 'Přidejte nářadí',
		'IMPLEMENT.ADD.SUCCESS': 'Nářadí bylo úspěšně přidáno',
		'IMPLEMENT.CLASS': 'Typ nářadí ',
		'IMPLEMENT.DELETE.QUESTION': 'Opravdu chcete smazat nářadí?',
		'IMPLEMENT.DELETE.SUCCESS': 'Nářadí bylo úspěšně vymazáno',
		'IMPLEMENT.DETAILS': 'Detaily nářadí',
		'IMPLEMENT.EDIT': 'Upravit nářadí',
		'IMPLEMENT.EDIT.SUCCESS': 'Nářadí bylo úspěšně upraveno',
		'IMPLEMENT.FIXED': 'Pevné nářadí',
		'IMPLEMENT.NO': 'Žádné nářadí',
		'IMPLEMENT.PROCESS.0': 'Chod naprázdno',
		'IMPLEMENT.PROCESS.1': 'Lisování kulatých balíků',
		'IMPLEMENT.PROCESS.10': 'Válcování',
		'IMPLEMENT.PROCESS.11': 'Setí',
		'IMPLEMENT.PROCESS.12': 'Výsadba',
		'IMPLEMENT.PROCESS.13': 'Hnojení',
		'IMPLEMENT.PROCESS.14': 'Stříkání',
		'IMPLEMENT.PROCESS.15': 'Zavlažování',
		'IMPLEMENT.PROCESS.16': 'Sekání',
		'IMPLEMENT.PROCESS.17': 'Otáčení',
		'IMPLEMENT.PROCESS.18': 'Přeprava',
		'IMPLEMENT.PROCESS.19': 'Zametání',
		'IMPLEMENT.PROCESS.2': 'Lisování hranatých balíků',
		'IMPLEMENT.PROCESS.20': 'Úklid sněhu',
		'IMPLEMENT.PROCESS.21': 'Posypávání solí',
		'IMPLEMENT.PROCESS.22': 'Okopávání',
		'IMPLEMENT.PROCESS.23': 'Hnojení',
		'IMPLEMENT.PROCESS.24': 'Čerpání kejdy',
		'IMPLEMENT.PROCESS.25': 'Míchání kejdy',
		'IMPLEMENT.PROCESS.26': 'Pěstování brambor',
		'IMPLEMENT.PROCESS.27': 'Sklizeň brambor',
		'IMPLEMENT.PROCESS.28': 'Oddělování',
		'IMPLEMENT.PROCESS.29': 'Hřebenování',
		'IMPLEMENT.PROCESS.3': 'Balení do balíků',
		'IMPLEMENT.PROCESS.30': 'Haulm poleva',
		'IMPLEMENT.PROCESS.31': 'Řádkování',
		'IMPLEMENT.PROCESS.32': 'Bránění/podmítání',
		'IMPLEMENT.PROCESS.33': 'Bránění/podmítání',
		'IMPLEMENT.PROCESS.34': 'Sekání',
		'IMPLEMENT.PROCESS.35': 'Zametání',
		'IMPLEMENT.PROCESS.36': 'Foukání sněhu',
		'IMPLEMENT.PROCESS.37': 'Pohyblivé kontejnery na tekutý hnůj',
		'IMPLEMENT.PROCESS.38': 'Tvarování lůžka',
		'IMPLEMENT.PROCESS.39': 'Krmení',
		'IMPLEMENT.PROCESS.4': 'Balení balíků',
		'IMPLEMENT.PROCESS.40': 'Přesun dřeva',
		'IMPLEMENT.PROCESS.41': 'Pila na dřevo',
		'IMPLEMENT.PROCESS.42': 'Štípané dřevo',
		'IMPLEMENT.PROCESS.43': 'Frézování pařezů',
		'IMPLEMENT.PROCESS.44': 'Nakládání sypkého materiálu',
		'IMPLEMENT.PROCESS.45': 'Nakládání palet',
		'IMPLEMENT.PROCESS.46': 'Nakládání balíků',
		'IMPLEMENT.PROCESS.47': 'Mlýny CCM převést',
		'IMPLEMENT.PROCESS.48': 'Posouvání',
		'IMPLEMENT.PROCESS.49': 'Hmotnost vpředu/zadu',
		'IMPLEMENT.PROCESS.5': 'Orba',
		'IMPLEMENT.PROCESS.50': 'Mlácení',
		'IMPLEMENT.PROCESS.51': 'Sekání',
		'IMPLEMENT.PROCESS.52': 'Balení vysokotlakých balíků',
		'IMPLEMENT.PROCESS.53': 'Odlistění',
		'IMPLEMENT.PROCESS.54': 'Plánování',
		'IMPLEMENT.PROCESS.55': 'Zpracování půdy',
		'IMPLEMENT.PROCESS.56': 'Péče o tělo',
		'IMPLEMENT.PROCESS.57': 'Montážní práce',
		'IMPLEMENT.PROCESS.58': 'Zaujmout',
		'IMPLEMENT.PROCESS.59': 'Nakládání a vykládání',
		'IMPLEMENT.PROCESS.6': 'Pěstování',
		'IMPLEMENT.PROCESS.60': 'Praní',
		'IMPLEMENT.PROCESS.61': 'Kompaktování',
		'IMPLEMENT.PROCESS.7': 'Bránění/podmítání',
		'IMPLEMENT.PROCESS.8': 'Hluboké uvolnění',
		'IMPLEMENT.PROCESS.9': 'Silové bránění',
		'IMPLEMENT.PROCESS.deadhead': 'Bez implementace',
		'IMPLEMENT.REMOVE': 'Odstranění nástroje',
		'IMPLEMENT.RESOURCE.0': 'Nedefinované',
		'IMPLEMENT.RESOURCE.1': 'Krmivo',
		'IMPLEMENT.RESOURCE.10': 'Hnůj',
		'IMPLEMENT.RESOURCE.11': 'Kejda',
		'IMPLEMENT.RESOURCE.12': 'Kompostování',
		'IMPLEMENT.RESOURCE.13': 'Digestát',
		'IMPLEMENT.RESOURCE.14': 'Dřevěné štěpky',
		'IMPLEMENT.RESOURCE.15': 'Kukuřice',
		'IMPLEMENT.RESOURCE.16': 'Slunečnice',
		'IMPLEMENT.RESOURCE.17': 'Čirok',
		'IMPLEMENT.RESOURCE.18': 'Žito',
		'IMPLEMENT.RESOURCE.19': 'Triticale',
		'IMPLEMENT.RESOURCE.2': 'Travní siláž',
		'IMPLEMENT.RESOURCE.20': 'Pšenice',
		'IMPLEMENT.RESOURCE.21': 'Polní fazole',
		'IMPLEMENT.RESOURCE.22': 'Hrách',
		'IMPLEMENT.RESOURCE.23': 'Polní tráva',
		'IMPLEMENT.RESOURCE.24': 'Jetelová tráva',
		'IMPLEMENT.RESOURCE.25': 'Ječmen',
		'IMPLEMENT.RESOURCE.26': 'Oves',
		'IMPLEMENT.RESOURCE.27': 'Špalda',
		'IMPLEMENT.RESOURCE.28': 'Camelina',
		'IMPLEMENT.RESOURCE.29': 'Lněné semínko',
		'IMPLEMENT.RESOURCE.3': 'Siláž celých rostlin',
		'IMPLEMENT.RESOURCE.30': 'řepka',
		'IMPLEMENT.RESOURCE.31': 'Sójové boby',
		'IMPLEMENT.RESOURCE.32': 'Úlovek plodin',
		'IMPLEMENT.RESOURCE.33': 'Cukrová řepa',
		'IMPLEMENT.RESOURCE.34': 'Brambory',
		'IMPLEMENT.RESOURCE.35': 'Miscanthus',
		'IMPLEMENT.RESOURCE.36': 'Topinambur',
		'IMPLEMENT.RESOURCE.37': 'Zelenina',
		'IMPLEMENT.RESOURCE.38': 'Jahody',
		'IMPLEMENT.RESOURCE.39': 'Kapalná hnojiva',
		'IMPLEMENT.RESOURCE.4': 'Hay',
		'IMPLEMENT.RESOURCE.40': 'Vápno',
		'IMPLEMENT.RESOURCE.41': 'Diamonfosfát',
		'IMPLEMENT.RESOURCE.42': 'Haarovy moučné pelety, PK, K, P, KAS',
		'IMPLEMENT.RESOURCE.43': 'Močovina',
		'IMPLEMENT.RESOURCE.44': 'Diesel',
		'IMPLEMENT.RESOURCE.45': 'AdBlue',
		'IMPLEMENT.RESOURCE.46': 'Pozemek',
		'IMPLEMENT.RESOURCE.47': 'Ochranný prostředek na rostliny',
		'IMPLEMENT.RESOURCE.48': 'Různé',
		'IMPLEMENT.RESOURCE.49': 'Voda',
		'IMPLEMENT.RESOURCE.5': 'CCM',
		'IMPLEMENT.RESOURCE.50': 'Krmná směs',
		'IMPLEMENT.RESOURCE.6': 'Kukuřice',
		'IMPLEMENT.RESOURCE.7': 'Sláma',
		'IMPLEMENT.RESOURCE.8': 'Kukuřičná siláž',
		'IMPLEMENT.RESOURCE.9': 'Obilí',
		'IMPLEMENT.TYPE': 'Typ implementace',
		'IMPLEMENT.TYPE.1': 'Lisy / baličky',
		'IMPLEMENT.TYPE.10': 'Přepravní přívěsy',
		'IMPLEMENT.TYPE.10_1': 'Třícestný sklápěč',
		'IMPLEMENT.TYPE.10_10': 'Nízkopodlažní přívěs',
		'IMPLEMENT.TYPE.10_11': 'Přívěs s hákovým zvedákem',
		'IMPLEMENT.TYPE.10_12': 'Přívěs pro hospodářská zvířata',
		'IMPLEMENT.TYPE.10_13': 'Přívěsný vozík pro návěs',
		'IMPLEMENT.TYPE.10_14': 'Cisterny/silové vozy',
		'IMPLEMENT.TYPE.10_2': 'Sklápěč karoserie',
		'IMPLEMENT.TYPE.10_3': 'Odpadkový koš Chaser',
		'IMPLEMENT.TYPE.10_4': 'Přívěs na plošinu',
		'IMPLEMENT.TYPE.10_5': 'Pásový vůz',
		'IMPLEMENT.TYPE.10_6': 'Silážní přívěs',
		'IMPLEMENT.TYPE.10_7': 'Přívěs pro přepravu balíků',
		'IMPLEMENT.TYPE.10_8': 'Odsuvný přívěs',
		'IMPLEMENT.TYPE.10_9': 'Cisterna na kejdu',
		'IMPLEMENT.TYPE.11': 'Vybavení pro hospodářská zvířata',
		'IMPLEMENT.TYPE.11_1': 'Vlečená míchačka',
		'IMPLEMENT.TYPE.11_2': 'Vůz na rozvoz krmiva',
		'IMPLEMENT.TYPE.11_3': 'Svozový/distribuční vůz',
		'IMPLEMENT.TYPE.12': 'Lesnictví',
		'IMPLEMENT.TYPE.12_1': 'Lesní přívěs',
		'IMPLEMENT.TYPE.12_2': 'Pila na palivové dřevo',
		'IMPLEMENT.TYPE.12_3': 'Zpracovatel palivového dřeva',
		'IMPLEMENT.TYPE.12_4': 'Štípač kmenů',
		'IMPLEMENT.TYPE.12_5': 'Bruska na pařezy',
		'IMPLEMENT.TYPE.12_6': 'Lesnický naviják',
		'IMPLEMENT.TYPE.12_7': 'Lesnický mulčovač',
		'IMPLEMENT.TYPE.12_8': 'Štěpkovač dřeva',
		'IMPLEMENT.TYPE.12_8_1': 'Namontovaný diskový štěpkovač',
		'IMPLEMENT.TYPE.12_8_2': 'Štěpkovač s taženým diskem',
		'IMPLEMENT.TYPE.12_8_3': 'Namontovaný bubnový štěpkovač',
		'IMPLEMENT.TYPE.12_8_4': 'Tažený bubnový štěpkovač',
		'IMPLEMENT.TYPE.12_8_5': 'Tažený bubnový štěpkovač (s vlastním pohonem)',
		'IMPLEMENT.TYPE.12_9': 'Hydraulický vyžínač okrajů',
		'IMPLEMENT.TYPE.13': 'Komunální zařízení',
		'IMPLEMENT.TYPE.13_1': 'Zametače',
		'IMPLEMENT.TYPE.13_10': 'Zařízení pro údržbu cest',
		'IMPLEMENT.TYPE.13_11': 'Banketní frézka',
		'IMPLEMENT.TYPE.13_12': 'Solnička - přiložena',
		'IMPLEMENT.TYPE.13_13': 'Nakladač',
		'IMPLEMENT.TYPE.13_14': 'Mycí zařízení',
		'IMPLEMENT.TYPE.13_15': 'Zavlažovací zařízení',
		'IMPLEMENT.TYPE.13_16': 'Pracovní platforma',
		'IMPLEMENT.TYPE.13_17': 'Povrchový mulčovač',
		'IMPLEMENT.TYPE.13_18': 'Přední část outriggeru',
		'IMPLEMENT.TYPE.13_18_1': 'Řezná hlava',
		'IMPLEMENT.TYPE.13_18_2': 'Mulčovací hlava',
		'IMPLEMENT.TYPE.13_18_3': 'Nůžky na živý plot',
		'IMPLEMENT.TYPE.13_18_4': 'Zúčtovací koš',
		'IMPLEMENT.TYPE.13_18_5': 'Hrábě',
		'IMPLEMENT.TYPE.13_19': 'Výstupní středisko/konstrukce',
		'IMPLEMENT.TYPE.13_19_1': 'Řezná hlava',
		'IMPLEMENT.TYPE.13_19_2': 'Mulčovací hlava',
		'IMPLEMENT.TYPE.13_19_3': 'Nůžky na živý plot',
		'IMPLEMENT.TYPE.13_19_4': 'Zúčtovací koš',
		'IMPLEMENT.TYPE.13_19_5': 'Hrábě',
		'IMPLEMENT.TYPE.13_1_1': 'Přední zametač',
		'IMPLEMENT.TYPE.13_1_2': 'Zadní zametač',
		'IMPLEMENT.TYPE.13_1_3': 'Struktura',
		'IMPLEMENT.TYPE.13_2': 'Sněhový pluh',
		'IMPLEMENT.TYPE.13_20': 'Zadní část výložníku',
		'IMPLEMENT.TYPE.13_20_1': 'Řezná hlava',
		'IMPLEMENT.TYPE.13_20_2': 'Mulčovací hlava',
		'IMPLEMENT.TYPE.13_20_3': 'Nůžky na živý plot',
		'IMPLEMENT.TYPE.13_20_4': 'Zúčtovací koš',
		'IMPLEMENT.TYPE.13_20_5': 'Hrábě',
		'IMPLEMENT.TYPE.13_21': 'Foukač listí',
		'IMPLEMENT.TYPE.13_22': 'Banketový kompaktor / lis na talíře',
		'IMPLEMENT.TYPE.13_3': 'Sněhový pluh - tvar V',
		'IMPLEMENT.TYPE.13_4': 'Sněhová fréza',
		'IMPLEMENT.TYPE.13_5': 'Namontované rozmetadlo',
		'IMPLEMENT.TYPE.13_6': 'Tažené rozmetadlo',
		'IMPLEMENT.TYPE.13_7': 'Sekačka u silnice',
		'IMPLEMENT.TYPE.13_8': 'Výsuvná sekačka',
		'IMPLEMENT.TYPE.13_9': 'Sekačka',
		'IMPLEMENT.TYPE.14': 'Zařízení pro čelní nakládání',
		'IMPLEMENT.TYPE.14_1': 'Kbelík',
		'IMPLEMENT.TYPE.14_2': 'Kbelík (velký objem)',
		'IMPLEMENT.TYPE.14_3': 'Paletové vidle',
		'IMPLEMENT.TYPE.14_4': 'Uchopovač balíků',
		'IMPLEMENT.TYPE.14_5': 'Vidlice na balíky',
		'IMPLEMENT.TYPE.14_6': 'Uchopení kbelíku',
		'IMPLEMENT.TYPE.14_7': 'Pracovní platforma',
		'IMPLEMENT.TYPE.14_8': 'Vidle na hnůj',
		'IMPLEMENT.TYPE.15': 'Sklízení příloh',
		'IMPLEMENT.TYPE.15_1': 'Řezání',
		'IMPLEMENT.TYPE.15_1_1': 'Standard řezání',
		'IMPLEMENT.TYPE.15_1_2': 'Řezání skládací',
		'IMPLEMENT.TYPE.15_2': 'Sběrač kukuřice',
		'IMPLEMENT.TYPE.15_2_1': 'Standardní sběrač kukuřice',
		'IMPLEMENT.TYPE.15_3': 'Hlavice na kukuřici',
		'IMPLEMENT.TYPE.15_4': 'Přípravek na silážování celých rostlin',
		'IMPLEMENT.TYPE.15_5': 'Pick-Up',
		'IMPLEMENT.TYPE.15_6': 'Zúčtování příloh',
		'IMPLEMENT.TYPE.15_7': 'Sací systém',
		'IMPLEMENT.TYPE.15_8': 'Sbírání pokosu',
		'IMPLEMENT.TYPE.16': 'Různé',
		'IMPLEMENT.TYPE.16_1': 'Mlýn na kaši CCM',
		'IMPLEMENT.TYPE.16_2': 'Přední váha',
		'IMPLEMENT.TYPE.16_3': 'Zadní hmotnost',
		'IMPLEMENT.TYPE.16_4': 'Tlačná čepel',
		'IMPLEMENT.TYPE.17': 'Sady a vinice',
		'IMPLEMENT.TYPE.17_1': 'Odklízecí pluh',
		'IMPLEMENT.TYPE.17_2': 'Výsadbový stroj',
		'IMPLEMENT.TYPE.17_3': 'Defoliátor',
		'IMPLEMENT.TYPE.17_4': 'Frézka na kořeny',
		'IMPLEMENT.TYPE.18': 'Pěstování zeleniny',
		'IMPLEMENT.TYPE.18_1': 'Sklízeč mrkve',
		'IMPLEMENT.TYPE.18_2': 'Sklízeč cibule',
		'IMPLEMENT.TYPE.18_4': 'Sklízeč žárovek',
		'IMPLEMENT.TYPE.18_5': 'Sklízeč póru',
		'IMPLEMENT.TYPE.19': 'Technologie cukrové řepy',
		'IMPLEMENT.TYPE.19_1': 'Sklízeč cukrové řepy - bunkrový sklízeč',
		'IMPLEMENT.TYPE.19_1_1': 'Sklízeč bunkrů',
		'IMPLEMENT.TYPE.19_1_2': 'Přetížení nebo',
		'IMPLEMENT.TYPE.1_1': 'Kulatý lis',
		'IMPLEMENT.TYPE.1_2': 'Čtvercový lis',
		'IMPLEMENT.TYPE.1_3': 'Kombinace lisování / balení',
		'IMPLEMENT.TYPE.1_4': 'Obal na balíky',
		'IMPLEMENT.TYPE.1_5': 'Lis s vysokou hustotou',
		'IMPLEMENT.TYPE.2': 'Kultivace půdy',
		'IMPLEMENT.TYPE.2_1': 'Pluh',
		'IMPLEMENT.TYPE.2_10': 'Rotační kypřič',
		'IMPLEMENT.TYPE.2_10_1': 'Rotační kypřič - namontovaný',
		'IMPLEMENT.TYPE.2_10_2': 'Rotary tiller - attached ',
		'IMPLEMENT.TYPE.2_11': 'Přední balička',
		'IMPLEMENT.TYPE.2_12': 'Váleček',
		'IMPLEMENT.TYPE.2_12_1': 'Váleček - namontovaný',
		'IMPLEMENT.TYPE.2_12_2': 'Váleček - přiložený',
		'IMPLEMENT.TYPE.2_13': 'Rotační brány',
		'IMPLEMENT.TYPE.2_13_1': 'Rotační brány - nesené',
		'IMPLEMENT.TYPE.2_13_2': 'Rotační brány - připojené',
		'IMPLEMENT.TYPE.2_14': 'Rotační kultivátor',
		'IMPLEMENT.TYPE.2_14_1': 'Rotační kultivátor - nesený',
		'IMPLEMENT.TYPE.2_14_2': 'Rotační kultivátor - připojen',
		'IMPLEMENT.TYPE.2_15': 'Kombinace osiva',
		'IMPLEMENT.TYPE.2_15_1': 'Výsevní kombinace - namontovaná',
		'IMPLEMENT.TYPE.2_15_2': 'Výsevní kombinace - v příloze',
		'IMPLEMENT.TYPE.2_16': 'Lisy',
		'IMPLEMENT.TYPE.2_17': 'Škrabky',
		'IMPLEMENT.TYPE.2_17_1': 'Škrabky - namontované',
		'IMPLEMENT.TYPE.2_17_2': 'Škrabky - přiloženy',
		'IMPLEMENT.TYPE.2_18': 'Brány na slámu',
		'IMPLEMENT.TYPE.2_18_1': 'Slaměné brány - nesené',
		'IMPLEMENT.TYPE.2_18_2': 'Slaměné brány - přiloženy',
		'IMPLEMENT.TYPE.2_19': 'Další pěstitelé',
		'IMPLEMENT.TYPE.2_19_1': 'Další nesené kultivátory - nesené',
		'IMPLEMENT.TYPE.2_19_2': 'Další kultivátory - v příloze',
		'IMPLEMENT.TYPE.2_1_1': 'Závěsný pluh',
		'IMPLEMENT.TYPE.2_1_2': 'Polonesený pluh',
		'IMPLEMENT.TYPE.2_1_3': 'Polonesený pluh (na pozemku)',
		'IMPLEMENT.TYPE.2_2': 'Kultivátor',
		'IMPLEMENT.TYPE.2_20': 'Další pěstitelé',
		'IMPLEMENT.TYPE.2_2_1': 'Nesený kultivátor',
		'IMPLEMENT.TYPE.2_2_2': 'Tažený kultivátor',
		'IMPLEMENT.TYPE.2_3': 'Kotoučové bránování',
		'IMPLEMENT.TYPE.2_3_1': 'Nesené diskové brány',
		'IMPLEMENT.TYPE.2_3_2': 'Vlečená brána',
		'IMPLEMENT.TYPE.2_4': 'Kompaktní kotoučová brána',
		'IMPLEMENT.TYPE.2_4_1': 'Kompaktní kotoučová brána - namontovaná',
		'IMPLEMENT.TYPE.2_4_2': 'Kompaktní kotoučová bránka - přiložena',
		'IMPLEMENT.TYPE.2_5': 'Hluboký uvolňovač',
		'IMPLEMENT.TYPE.2_5_1': 'Hloubkový uvolňovač - namontovaný',
		'IMPLEMENT.TYPE.2_5_2': 'Hloubkové uvolňovače - přiloženy',
		'IMPLEMENT.TYPE.2_6': 'rýčovací stroj',
		'IMPLEMENT.TYPE.2_6_1': 'rýčovací stroj - namontovaný',
		'IMPLEMENT.TYPE.2_6_2': 'rýčovací stroj - přiloženo',
		'IMPLEMENT.TYPE.2_7': 'Rotační brány',
		'IMPLEMENT.TYPE.2_7_1': 'Rotační brány - nesené',
		'IMPLEMENT.TYPE.2_7_2': 'Rotační brány - připojené',
		'IMPLEMENT.TYPE.2_8': 'Rotační motyka',
		'IMPLEMENT.TYPE.2_8_1': 'Rotační motyka - namontovaná',
		'IMPLEMENT.TYPE.2_8_2': 'Rotační motyka - přiložena',
		'IMPLEMENT.TYPE.2_9': 'Pístové bránování',
		'IMPLEMENT.TYPE.2_9_1': 'Pístové brány - nesené',
		'IMPLEMENT.TYPE.2_9_2': 'Pístové bránování - připojeno',
		'IMPLEMENT.TYPE.3': 'Secí stroje/sázecí stroje',
		'IMPLEMENT.TYPE.3_1': 'Mechanický secí stroj',
		'IMPLEMENT.TYPE.3_1_1': 'Mechanický secí stroj - namontovaný',
		'IMPLEMENT.TYPE.3_1_2': 'Mechanický secí stroj - připojen',
		'IMPLEMENT.TYPE.3_1_3': 'Mechanická výsevní kombinace - namontovaná',
		'IMPLEMENT.TYPE.3_1_4': 'Mechanická výsevní kombinace - v příloze',
		'IMPLEMENT.TYPE.3_2': 'Pneumatický secí stroj',
		'IMPLEMENT.TYPE.3_2_1': 'Pneumatický secí stroj - namontovaný',
		'IMPLEMENT.TYPE.3_2_2': 'Pneumatický secí stroj - připojen',
		'IMPLEMENT.TYPE.3_2_3': 'Pneumatická secí kombinace - namontovaná',
		'IMPLEMENT.TYPE.3_2_4': 'Pneumatická secí kombinace - v příloze',
		'IMPLEMENT.TYPE.3_3': 'Přesný mechanický secí stroj',
		'IMPLEMENT.TYPE.3_3_1': 'Přesný mechanický secí stroj - montovaný',
		'IMPLEMENT.TYPE.3_3_2': 'Přesný mechanický secí stroj - připojen',
		'IMPLEMENT.TYPE.3_3_3': 'Přesná mechanická výsevní kombinace - namontovaná',
		'IMPLEMENT.TYPE.3_3_4': 'Přesná mechanická secí kombinace - v příloze',
		'IMPLEMENT.TYPE.3_4': 'Přesný pneumatický secí stroj',
		'IMPLEMENT.TYPE.3_4_1': 'Přesný pneumatický secí stroj - namontovaný',
		'IMPLEMENT.TYPE.3_4_2': 'Přesný pneumatický secí stroj - připojen',
		'IMPLEMENT.TYPE.3_4_3': 'Přesné pneumatické výsevní kombinace - namontované',
		'IMPLEMENT.TYPE.3_4_4': 'Kombinace přesného výsevu vzduchem - v příloze',
		'IMPLEMENT.TYPE.3_5': 'Přímý výsev',
		'IMPLEMENT.TYPE.3_5_1': 'Přímý výsev - nesený',
		'IMPLEMENT.TYPE.3_5_2': 'Přímý výsev - přiloženo',
		'IMPLEMENT.TYPE.3_6': 'Jednozrnný secí stroj pro přímé setí',
		'IMPLEMENT.TYPE.3_6_1': 'Jednozrnný secí stroj pro přímé setí - nesený',
		'IMPLEMENT.TYPE.3_6_2': 'Jednozrnný secí stroj pro přímé setí - připojen',
		'IMPLEMENT.TYPE.3_7': 'Sázecí stroj',
		'IMPLEMENT.TYPE.3_7_1': 'Sázecí stroj - namontovaný',
		'IMPLEMENT.TYPE.3_7_2': 'Sázecí nádoba - přiložena',
		'IMPLEMENT.TYPE.3_8': 'Secí stroj na trávu',
		'IMPLEMENT.TYPE.3_8_1': 'Vysévač travních porostů - nesený',
		'IMPLEMENT.TYPE.3_8_2': 'Výsevní zařízení pro travní porosty - přiloženo',
		'IMPLEMENT.TYPE.3_9': 'Přední nádrž',
		'IMPLEMENT.TYPE.4': 'Rozmetadlo',
		'IMPLEMENT.TYPE.4_1': 'Rozmetadlo - namontované',
		'IMPLEMENT.TYPE.4_2': 'Rozmetadlo - připojeno',
		'IMPLEMENT.TYPE.5': 'Ochrana rostlin',
		'IMPLEMENT.TYPE.5_1': 'Postřikovač - namontovaný',
		'IMPLEMENT.TYPE.5_2': 'Postřikovač - připojen',
		'IMPLEMENT.TYPE.5_3': 'Motyka',
		'IMPLEMENT.TYPE.5_3_1': 'Motyka - namontovaná',
		'IMPLEMENT.TYPE.5_3_2': 'Motyka - přiložena',
		'IMPLEMENT.TYPE.5_4': 'Plečky',
		'IMPLEMENT.TYPE.5_4_1': 'Plečky - namontované',
		'IMPLEMENT.TYPE.5_4_2': 'Odplevelení - přiloženo',
		'IMPLEMENT.TYPE.6': 'Technologie hnojení',
		'IMPLEMENT.TYPE.6_1': 'Rozmetadlo hnoje/kompostu',
		'IMPLEMENT.TYPE.6_2': 'Cisterna na kejdu',
		'IMPLEMENT.TYPE.6_2_1': 'Přesný rozptylovač',
		'IMPLEMENT.TYPE.6_2_2': 'Výložník kapací hadice',
		'IMPLEMENT.TYPE.6_2_3': 'Rozmetadlo tažných bot',
		'IMPLEMENT.TYPE.6_2_4': 'Injektor kultivátoru',
		'IMPLEMENT.TYPE.6_2_5': 'Injektor diskové brány',
		'IMPLEMENT.TYPE.6_2_6': 'Injektor diskové frézy',
		'IMPLEMENT.TYPE.6_2_7': 'Injektor Striptill',
		'IMPLEMENT.TYPE.6_2_8': 'Otočné rozdělovače',
		'IMPLEMENT.TYPE.6_3': 'Kalové čerpadlo',
		'IMPLEMENT.TYPE.6_4': 'Směšovač kejdy',
		'IMPLEMENT.TYPE.6_5': 'Nádoba na kejdu',
		'IMPLEMENT.TYPE.6_6': 'Hadicový systém',
		'IMPLEMENT.TYPE.6_6_1': 'Rozdělovač vlečných hadic',
		'IMPLEMENT.TYPE.6_6_2': 'Distributor tažných bot',
		'IMPLEMENT.TYPE.6_6_3': 'Injektorový kotouč na kejdu',
		'IMPLEMENT.TYPE.6_6_4': 'Kultivátor na kejdu',
		'IMPLEMENT.TYPE.6_6_5': 'Diskové brány na kejdu',
		'IMPLEMENT.TYPE.6_6_6': 'Injektor kejdy',
		'IMPLEMENT.TYPE.6_6_7': 'Otočný rozdělovač',
		'IMPLEMENT.TYPE.7': 'Zavlažovací technologie',
		'IMPLEMENT.TYPE.7_1': 'Cestovatel pro zavlažování',
		'IMPLEMENT.TYPE.7_2': 'Zavlažovací rameno',
		'IMPLEMENT.TYPE.8': 'Zařízení na brambory',
		'IMPLEMENT.TYPE.8_1': 'Sázeč brambor',
		'IMPLEMENT.TYPE.8_1_1': 'Sázecí stroj bez rotačního kypřiče',
		'IMPLEMENT.TYPE.8_1_2': 'Sázecí stroj s rotačním kypřičem',
		'IMPLEMENT.TYPE.8_1_3': 'Sázecí stroj bez rotačního kypřiče - připojený',
		'IMPLEMENT.TYPE.8_1_4': 'Sázecí stroj s rotačním kypřičem - nesený',
		'IMPLEMENT.TYPE.8_2': 'Sklízeč brambor - shrnovač',
		'IMPLEMENT.TYPE.8_3': 'Sklízeč brambor - s bunkrem',
		'IMPLEMENT.TYPE.8_4': 'Sklízeč brambor - výtah',
		'IMPLEMENT.TYPE.8_5': 'Bývalý hřeben',
		'IMPLEMENT.TYPE.8_6': 'Oddělovač',
		'IMPLEMENT.TYPE.8_7': 'Rotační kypřič',
		'IMPLEMENT.TYPE.8_8': 'Vrchní část vozíku',
		'IMPLEMENT.TYPE.9': 'Vybavení pastvin',
		'IMPLEMENT.TYPE.9_1': 'Bubnová sekačka',
		'IMPLEMENT.TYPE.9_1_1': 'Bubnová sekačka s kondicionérem',
		'IMPLEMENT.TYPE.9_1_2': 'Bubnová sekačka bez kondicionéru',
		'IMPLEMENT.TYPE.9_1_3': 'Bubnová sekačka s kondicionérem - nesená',
		'IMPLEMENT.TYPE.9_1_4': 'Bubnová sekačka bez kondicionéru - připojená',
		'IMPLEMENT.TYPE.9_2': 'Diskové sekačky',
		'IMPLEMENT.TYPE.9_2_1': 'Disková sekačka s kondicionérem',
		'IMPLEMENT.TYPE.9_2_2': 'Diskové sekačky bez kondicionéru',
		'IMPLEMENT.TYPE.9_2_3': 'Diskové sekačky s kondicionérem - namontované',
		'IMPLEMENT.TYPE.9_2_4': 'Diskové sekačky bez kondicionéru - připojené',
		'IMPLEMENT.TYPE.9_3': 'Rotační rozrývač',
		'IMPLEMENT.TYPE.9_3_1': 'Rotační rozrývač - namontovaný',
		'IMPLEMENT.TYPE.9_3_2': 'Rotační rozrývač - přiloženo',
		'IMPLEMENT.TYPE.9_4': 'Shrnovač',
		'IMPLEMENT.TYPE.9_4_1': 'Jednorotorový shrnovač',
		'IMPLEMENT.TYPE.9_4_2': 'Dvourotorový shrnovač (pokládání bočního pokosu)',
		'IMPLEMENT.TYPE.9_4_3': 'Dvourotorový shrnovač (pokládka do středového pokosu)',
		'IMPLEMENT.TYPE.9_4_4': 'Čtyřrotorový shrnovač',
		'IMPLEMENT.TYPE.9_4_5': ' Průběžné slučování ',
		'IMPLEMENT.TYPE.9_4_6': 'Rotační hrábě',
		'IMPLEMENT.TYPE.9_5': 'Brány na pastviny',
		'IMPLEMENT.TYPE.9_6': 'Brány na pastviny',
		'IMPLEMENT.TYPE.9_7': 'Travní válec',
		'IMPLEMENT.TYPE.9_8': 'Vrtulník',
		'IMPLEMENTS': 'Nářadí',
		'IMPLEMENTS.ALL': 'Všechny Nářadí',
		'IMPLEMENTS.DEACTIVATE.FAILURE': 'Některé nástroje nebylo možné deaktivovat.',
		'IMPLEMENTS.DEACTIVATE.QUESTION': 'Opravdu chcete deaktivovat vybrané nástroje?',
		'IMPLEMENTS.DEACTIVATE.SUCCESS': 'Úspěšná deaktivace nástrojů',
		'IMPLEMENTS.DELETE.FAILURE': 'Některé Nářadí nebylo možné odstranit.',
		'IMPLEMENTS.DELETE.QUESTION': 'Opravdu chcete odstranit vybrané Nářadí?',
		'IMPLEMENTS.DELETE.SUCCESS': 'Nářadí byly odstraněny',
		'IMPLEMENTS.MANAGEMENT': 'Nářadí řízení',
		'IMPLEMENTS.NO': 'Žádné Nářadí',
		'IMPLEMENTS.NOT_SELECTED': 'Žádné vybrané nářadí',
		'IMPLEMENTS.REACTIVATE.FAILURE': 'Některé nástroje nebylo možné znovu aktivovat.',
		'IMPLEMENTS.REACTIVATE.QUESTION': 'Opravdu chcete vybrané nástroje znovu aktivovat?',
		'IMPLEMENTS.REACTIVATE.SUCCESS': 'Úspěšná reaktivace nástrojů',
		'IMPLEMENTS.SELECTED': 'Vybrané Nářadí',
		'IMPLEMENT_SCAN_DISABLED': 'Implementace neaktivního skenování majáku',
		'IMPORT': 'Import',
		'INACTIVE': 'Neaktivní',
		'INDIVIDUAL_LABELING': 'Vlastní označování',
		'INFO': 'Informace',
		'INTERPOLATION.MAP': 'Interpolační mapa',
		'INTERPOLATION.MAP.SETTINGS': 'Nastavení interpolační mapy',
		'IO_BOX_ACTIVATED': 'IOBox aktivní',
		'ISOBUS.DDI.1': 'Nastavený objem na plochu Aplikační rychlost',
		'ISOBUS.DDI.10': 'Maximální hmotnostní dávka na plochu',
		'ISOBUS.DDI.100': 'Kontaminace plodin',
		'ISOBUS.DDI.101': 'Nastavená šířka balíku',
		'ISOBUS.DDI.102': 'Skutečná šířka balíku',
		'ISOBUS.DDI.103': 'Výchozí šířka balíku',
		'ISOBUS.DDI.104': 'Minimální šířka balíku',
		'ISOBUS.DDI.105': 'Maximální šířka balíku',
		'ISOBUS.DDI.106': 'Nastavená výška balíku',
		'ISOBUS.DDI.107': 'Skutečná výška balíku',
		'ISOBUS.DDI.108': 'Výchozí výška balíku',
		'ISOBUS.DDI.109': 'Minimální výška balíku',
		'ISOBUS.DDI.11': 'Počet nastavených hodnot na plochu Aplikační rychlost',
		'ISOBUS.DDI.110': 'Maximální výška balíku',
		'ISOBUS.DDI.111': 'Nastavená velikost balíku',
		'ISOBUS.DDI.112': 'Skutečná velikost balíku',
		'ISOBUS.DDI.113': 'Výchozí velikost balíku',
		'ISOBUS.DDI.114': 'Minimální velikost balíku',
		'ISOBUS.DDI.115': 'Maximální velikost balíku',
		'ISOBUS.DDI.116': 'Celková plocha',
		'ISOBUS.DDI.117': 'Efektivní celková vzdálenost',
		'ISOBUS.DDI.118': 'Neefektivní celková vzdálenost',
		'ISOBUS.DDI.119': 'Efektivní celkový čas',
		'ISOBUS.DDI.12': 'Skutečný počet na plochu Aplikační sazba',
		'ISOBUS.DDI.120': 'Neefektivní celkový čas',
		'ISOBUS.DDI.121': 'Hustota výrobku Hmotnost na objem',
		'ISOBUS.DDI.122': 'Hustota produktu Hmotnost na počet',
		'ISOBUS.DDI.123': 'Hustota produktu Objem na počet',
		'ISOBUS.DDI.124': 'Prodloužení stupnice pomocného ventilu',
		'ISOBUS.DDI.125': 'Stahování stupnice pomocného ventilu',
		'ISOBUS.DDI.126': 'Vysunutí rampy pomocného ventilu nahoru',
		'ISOBUS.DDI.127': 'Vysunutí pomocné rampy ventilu směrem dolů',
		'ISOBUS.DDI.128': 'Zatažení pomocného ventilu rampy nahoru',
		'ISOBUS.DDI.129': 'Zatažení pomocného ventilu rampy dolů',
		'ISOBUS.DDI.13': 'Výchozí počet na plochu',
		'ISOBUS.DDI.130': 'Prahová hodnota plováku pomocného ventilu',
		'ISOBUS.DDI.131': 'Prodloužení progresivity pomocného ventilu',
		'ISOBUS.DDI.132': 'Stahování progresivity pomocného ventilu',
		'ISOBUS.DDI.133': 'Inverzní porty pomocného ventilu',
		'ISOBUS.DDI.134': 'Posun prvku zařízení X',
		'ISOBUS.DDI.135': 'Posun prvku zařízení Y',
		'ISOBUS.DDI.136': 'Posun prvku zařízení Z',
		'ISOBUS.DDI.137': 'Objemová kapacita zařízení',
		'ISOBUS.DDI.138': 'Hmotnostní kapacita zařízení',
		'ISOBUS.DDI.139': ' Device Count Capacity ',
		'ISOBUS.DDI.14': 'Minimální počet na plochu Aplikační dávka',
		'ISOBUS.DDI.140': 'Nastavené procento aplikační dávky',
		'ISOBUS.DDI.141': 'Aktuální pracovní stav',
		'ISOBUS.DDI.142': 'Fyzická časová prodleva nastavené hodnoty',
		'ISOBUS.DDI.143': 'Fyzická skutečná hodnota Časová latence',
		'ISOBUS.DDI.144': 'Úhel odklonu',
		'ISOBUS.DDI.145': 'Úhel převrácení',
		'ISOBUS.DDI.146': 'Úhel sklonu',
		'ISOBUS.DDI.147': 'Počet záznamů',
		'ISOBUS.DDI.148': 'Celková spotřeba paliva',
		'ISOBUS.DDI.149': 'Spotřeba paliva za čas',
		'ISOBUS.DDI.15': 'Maximální počet na plochu Aplikační dávka',
		'ISOBUS.DDI.150': 'Spotřeba paliva na plochu',
		'ISOBUS.DDI.151': 'Plocha za časovou kapacitu',
		'ISOBUS.DDI.153': 'Skutečný normalizovaný rozdílový vegetační index (NDVI)',
		'ISOBUS.DDI.154': 'Délka fyzického objektu',
		'ISOBUS.DDI.155': 'Šířka fyzického objektu',
		'ISOBUS.DDI.156': 'Výška fyzického objektu',
		'ISOBUS.DDI.157': 'Typ konektoru',
		'ISOBUS.DDI.158': 'Stát kontroly předepisování',
		'ISOBUS.DDI.159': 'Počet dílčích jednotek na oddíl',
		'ISOBUS.DDI.16': 'Rozteč nastavených hodnot Rychlost aplikace',
		'ISOBUS.DDI.160': 'Stav kontroly sekce',
		'ISOBUS.DDI.161': 'Skutečný zkrácený pracovní stav (1-16)',
		'ISOBUS.DDI.162': 'Skutečný zkrácený pracovní stav (17-32)',
		'ISOBUS.DDI.163': 'Skutečný zkrácený pracovní stav (33-48)',
		'ISOBUS.DDI.164': 'Skutečný zkrácený pracovní stav (49-64)',
		'ISOBUS.DDI.165': 'Skutečný zkrácený pracovní stav (65-80)',
		'ISOBUS.DDI.166': 'Skutečný zkrácený pracovní stav(81-96)',
		'ISOBUS.DDI.167': 'Skutečný zhuštěný pracovní stav (97-112)',
		'ISOBUS.DDI.168': 'Skutečný zhuštěný pracovní stav (113-128)',
		'ISOBUS.DDI.169': 'Skutečný zhuštěný pracovní stav (129-144)',
		'ISOBUS.DDI.17': 'Skutečná rozteč aplikační dávky',
		'ISOBUS.DDI.170': 'Skutečný zhuštěný pracovní stav  (145-160)',
		'ISOBUS.DDI.171': 'Skutečný zhuštěný pracovní stav  (161-176)',
		'ISOBUS.DDI.172': 'Skutečný zhuštěný pracovní stav  (177-192)',
		'ISOBUS.DDI.173': 'Skutečný zhuštěný pracovní stav  (193-208)',
		'ISOBUS.DDI.174': 'Skutečný zhuštěný pracovní stav  (209-224)',
		'ISOBUS.DDI.175': 'Skutečný zhuštěný pracovní stav  (225-240)',
		'ISOBUS.DDI.176': 'Skutečný zhuštěný pracovní stav (241-256)',
		'ISOBUS.DDI.177': 'Skutečná délka řezu',
		'ISOBUS.DDI.178': 'Typ prvku Instance',
		'ISOBUS.DDI.179': 'Skutečná kulturní praxe',
		'ISOBUS.DDI.18': 'Výchozí rozteč aplikační dávky',
		'ISOBUS.DDI.180': 'Vzdálenost referenčního bodu zařízení (DRP) od země',
		'ISOBUS.DDI.181': 'Výnos suché hmoty na plochu',
		'ISOBUS.DDI.182': 'Výnos suché hmoty za čas',
		'ISOBUS.DDI.183': 'Výnos Celková suchá hmotnost',
		'ISOBUS.DDI.184': 'Referenční vlhkost pro suchou hmotnost',
		'ISOBUS.DDI.185': 'Hmotnost osiva bavlny na plochu Výnos',
		'ISOBUS.DDI.186': 'Vláknina Hmotnost bavlny na plochu Výnos',
		'ISOBUS.DDI.187': 'Hmotnost osiva bavlny za čas Výnos',
		'ISOBUS.DDI.188': 'Hmotnost bavlny za čas Výnos',
		'ISOBUS.DDI.189': 'Výnos Celkové osivo Hmotnost bavlny',
		'ISOBUS.DDI.19': 'Minimální rozteč aplikační dávky',
		'ISOBUS.DDI.190': 'Výnos Vlákno celkem Hmotnost bavlny',
		'ISOBUS.DDI.191': 'Procento obrátkovosti',
		'ISOBUS.DDI.192': 'Okolní teplota',
		'ISOBUS.DDI.193': 'Nastavená hodnota tlaku produktu',
		'ISOBUS.DDI.194': 'Skutečný tlak výrobku',
		'ISOBUS.DDI.195': 'Minimální tlak na výrobek',
		'ISOBUS.DDI.196': 'Maximální tlak výrobku',
		'ISOBUS.DDI.197': 'Nastavená hodnota výstupního tlaku čerpadla',
		'ISOBUS.DDI.198': 'Skutečný výstupní tlak čerpadla',
		'ISOBUS.DDI.199': 'Minimální výstupní tlak čerpadla',
		'ISOBUS.DDI.2': 'Skutečný objem na plochu',
		'ISOBUS.DDI.20': 'Maximální rozteč aplikační dávky',
		'ISOBUS.DDI.200': 'Maximální výstupní tlak čerpadla',
		'ISOBUS.DDI.201': 'Nastavený tlak míchání v nádrži',
		'ISOBUS.DDI.202': 'Skutečný míchací tlak v nádrži',
		'ISOBUS.DDI.203': 'Minimální tlak míchání v nádrži',
		'ISOBUS.DDI.204': 'Maximální tlak míchání v nádrži',
		'ISOBUS.DDI.205': 'Čas zapnutí SC',
		'ISOBUS.DDI.206': 'Čas vypnutí SC',
		'ISOBUS.DDI.207': 'Rychlost větru',
		'ISOBUS.DDI.208': 'Směr větru',
		'ISOBUS.DDI.209': 'Relativní vlhkost',
		'ISOBUS.DDI.21': 'Nastavený objem na objem Aplikační rychlost',
		'ISOBUS.DDI.210': 'Podmínky na obloze',
		'ISOBUS.DDI.211': 'Poslední balík Vločky na balík',
		'ISOBUS.DDI.212': 'Poslední balík Průměrná vlhkost',
		'ISOBUS.DDI.213': 'Poslední balík Průměrný počet tahů na vločku',
		'ISOBUS.DDI.214': 'Počet balíků za celou dobu životnosti',
		'ISOBUS.DDI.215': 'Celoživotní pracovní doba',
		'ISOBUS.DDI.216': 'Skutečný hydraulický tlak balíků',
		'ISOBUS.DDI.217': 'Poslední balík Průměrný hydraulický tlak',
		'ISOBUS.DDI.218': 'Nastavená hodnota zatížení stlačení balíku plunžrem',
		'ISOBUS.DDI.219': 'Skutečné zatížení pístu při stlačování balíků',
		'ISOBUS.DDI.22': 'Skutečný objem na objem aplikační dávky',
		'ISOBUS.DDI.220': 'Poslední balík Průměrné stlačení balíku Zatížení pístu',
		'ISOBUS.DDI.221': 'Poslední balík aplikované konzervační látky',
		'ISOBUS.DDI.222': 'Číslo posledního štítku balíku',
		'ISOBUS.DDI.223': 'Poslední balíková mše',
		'ISOBUS.DDI.224': 'Delta T',
		'ISOBUS.DDI.225': 'Nastavená pracovní délka',
		'ISOBUS.DDI.226': 'Skutečná pracovní délka',
		'ISOBUS.DDI.227': 'Minimální pracovní délka',
		'ISOBUS.DDI.228': 'Maximální pracovní délka',
		'ISOBUS.DDI.229': 'Skutečná čistá hmotnost',
		'ISOBUS.DDI.23': 'Výchozí aplikační dávka na objem',
		'ISOBUS.DDI.230': 'Čistá hmotnost Stav',
		'ISOBUS.DDI.231': 'Nastavená čistá hmotnost',
		'ISOBUS.DDI.232': 'Skutečná hrubá hmotnost',
		'ISOBUS.DDI.233': 'Hrubá hmotnost Stát',
		'ISOBUS.DDI.234': 'Minimální hrubá hmotnost',
		'ISOBUS.DDI.235': 'Maximální celková hmotnost',
		'ISOBUS.DDI.236': 'Celkový čas zapojení mlátičky',
		'ISOBUS.DDI.237': 'Skutečná pracovní výška hlavičky Stav',
		'ISOBUS.DDI.238': 'Skutečná rychlost otáčení hlavičky Stav',
		'ISOBUS.DDI.239': 'Stav držení výnosu',
		'ISOBUS.DDI.24': 'Minimální objem na objem Aplikační dávka',
		'ISOBUS.DDI.240': 'Aktuální stav systému (ne)nakládání',
		'ISOBUS.DDI.241': 'Teplota plodin',
		'ISOBUS.DDI.242': 'Nastavený průchod sítem',
		'ISOBUS.DDI.243': 'Skutečná světlost síta',
		'ISOBUS.DDI.244': 'Minimální průchodnost sít',
		'ISOBUS.DDI.245': 'Maximální průchodnost sít',
		'ISOBUS.DDI.246': 'Vůle nastavené hodnoty Chaffer',
		'ISOBUS.DDI.247': 'Skutečný volný prostor Chaffer',
		'ISOBUS.DDI.248': 'Minimální světlá výška',
		'ISOBUS.DDI.249': 'Maximální světlá výška',
		'ISOBUS.DDI.25': 'Maximální objem na objem aplikační dávky',
		'ISOBUS.DDI.250': 'Nastavení konkávní vůle',
		'ISOBUS.DDI.251': 'Skutečná konkávní vůle',
		'ISOBUS.DDI.252': 'Minimální konkávní vůle',
		'ISOBUS.DDI.253': 'Maximální konkávní vůle',
		'ISOBUS.DDI.254': 'Oddělení nastavené hodnoty otáček ventilátoru',
		'ISOBUS.DDI.255': 'Skutečná oddělovací rychlost otáčení ventilátoru',
		'ISOBUS.DDI.256': 'Minimální oddělovací otáčky ventilátoru',
		'ISOBUS.DDI.257': 'Maximální oddělovací otáčky ventilátoru',
		'ISOBUS.DDI.258': 'Teplota hydraulického oleje',
		'ISOBUS.DDI.259': 'Zpoždění výnosu Ignorovat čas',
		'ISOBUS.DDI.26': 'Nastavená hmotnost na hmotnostní dávku',
		'ISOBUS.DDI.260': 'Výnosy Předstih Ignorovat čas',
		'ISOBUS.DDI.261': 'Průměrná hmotnost výtěžku za čas',
		'ISOBUS.DDI.262': 'Průměrná vlhkost plodin',
		'ISOBUS.DDI.263': 'Průměrná výnosová hmotnost na plochu',
		'ISOBUS.DDI.264': 'Posunutí konektoru X',
		'ISOBUS.DDI.265': 'Zbývající plocha',
		'ISOBUS.DDI.266': 'Aplikace po dobu životnosti Celková hmotnost',
		'ISOBUS.DDI.267': 'Celkový počet aplikací za celou dobu životnosti',
		'ISOBUS.DDI.268': 'Výnos za celou dobu životnosti Celkový objem',
		'ISOBUS.DDI.269': 'Životnost Výnos Celková hmotnost',
		'ISOBUS.DDI.27': 'Skutečná hmotnost na hmotnostní dávku',
		'ISOBUS.DDI.270': 'Výnos za celou dobu životnosti Celkový počet',
		'ISOBUS.DDI.271': 'Životnost Celková plocha',
		'ISOBUS.DDI.272': 'Životnost Efektivní celková vzdálenost',
		'ISOBUS.DDI.273': 'Neefektivní celková vzdálenost za celou dobu životnosti',
		'ISOBUS.DDI.274': 'Lebenszeit Effektive Gesamtzeit',
		'ISOBUS.DDI.275': 'Neefektivní celková doba životnosti',
		'ISOBUS.DDI.276': 'Spotřeba paliva za celou dobu životnosti',
		'ISOBUS.DDI.277': 'Průměrná spotřeba paliva za dobu životnosti',
		'ISOBUS.DDI.278': 'Průměrná spotřeba paliva na plochu za celou dobu životnosti',
		'ISOBUS.DDI.279': 'Výnos po dobu životnosti Celková suchá hmotnost',
		'ISOBUS.DDI.28': 'Výchozí hmotnost na hmotnostní dávku',
		'ISOBUS.DDI.280': 'Výnos za celou dobu životnosti Celková hmotnost osiva bavlny',
		'ISOBUS.DDI.281': 'Výnos za celou dobu životnosti Celková hmotnost vláknité bavlny',
		'ISOBUS.DDI.282': 'Celkový čas mlácení po celou dobu životnosti',
		'ISOBUS.DDI.283': 'Předřezaný celkový počet',
		'ISOBUS.DDI.284': 'Nekráceno Celkový počet',
		'ISOBUS.DDI.285': 'Celkový počet předřezů za celou dobu životnosti',
		'ISOBUS.DDI.286': 'Celoživotní nezkrácený celkový počet',
		'ISOBUS.DDI.287': 'Režim předepisování nastavené hodnoty',
		'ISOBUS.DDI.288': 'Režim skutečného předpisu',
		'ISOBUS.DDI.289': 'Pracovní stav nastavené hodnoty',
		'ISOBUS.DDI.29': 'Minimální hmotnost na hmotnostní dávku',
		'ISOBUS.DDI.290': 'Nastavená hodnota Kondenzovaný pracovní stav (1-16)',
		'ISOBUS.DDI.291': 'Nastavená hodnota zhuštěného pracovního stavu (17-32)',
		'ISOBUS.DDI.292': 'Nastavená hodnota zhuštěného pracovního stavu (33-48)',
		'ISOBUS.DDI.293': 'Nastavená hodnota zhuštěného pracovního stavu (49-64)',
		'ISOBUS.DDI.294': 'Nastavená hodnota Kondenzovaný pracovní stav (65-80) ',
		'ISOBUS.DDI.295': 'Nastavená hodnota Kondenzovaný pracovní stav  (81-96) ',
		'ISOBUS.DDI.296': 'Nastavená hodnota Kondenzovaný pracovní stav (97-112) ',
		'ISOBUS.DDI.297': 'Nastavená hodnota Kondenzovaný pracovní stav (113-128) ',
		'ISOBUS.DDI.298': 'Nastavená hodnota Kondenzovaný pracovní stav  (129-144) ',
		'ISOBUS.DDI.299': 'Nastavená hodnota Kondenzovaný pracovní stav (145-160) ',
		'ISOBUS.DDI.3': 'Výchozí aplikační dávka na plochu',
		'ISOBUS.DDI.30': 'Maximální hmotnost na hmotnostní dávku',
		'ISOBUS.DDI.300': 'Nastavená hodnota zhuštěného pracovního stavu (161-176)',
		'ISOBUS.DDI.301': 'Nastavení zhuštěného pracovního stavu (177-192)',
		'ISOBUS.DDI.302': 'Nastavení zhuštěného pracovního stavu (193-208) ',
		'ISOBUS.DDI.303': 'Nastavení zhuštěného pracovního stavu (209-224) ',
		'ISOBUS.DDI.304': 'Nastavení zhuštěného pracovního stavu  (225-240) ',
		'ISOBUS.DDI.305': 'Nastavení zhuštěného pracovního stavu  (241-256) ',
		'ISOBUS.DDI.306': 'Pravý bod otáčení X-Offset',
		'ISOBUS.DDI.307': 'Pravý bod rotace Y-Offset',
		'ISOBUS.DDI.308': 'Skutečná procentní míra aplikace',
		'ISOBUS.DDI.309': 'Minimální procentní míra aplikace',
		'ISOBUS.DDI.31': 'Nastavený objem na hmotnostní dávku',
		'ISOBUS.DDI.310': 'Maximální procentuální dávka',
		'ISOBUS.DDI.311': 'Relativní výnosový potenciál',
		'ISOBUS.DDI.312': 'Minimální relativní výnosový potenciál',
		'ISOBUS.DDI.313': 'Maximální relativní výnosový potenciál',
		'ISOBUS.DDI.314': 'Skutečné procento sušiny plodiny',
		'ISOBUS.DDI.315': 'Průměrné procento sušiny plodiny',
		'ISOBUS.DDI.316': 'Efektivní celková spotřeba paliva',
		'ISOBUS.DDI.317': 'Neefektivní celková spotřeba paliva',
		'ISOBUS.DDI.318': 'Efektivní celková spotřeba výfukových plynů vznětových motorů',
		'ISOBUS.DDI.319': 'Neefektivní celková spotřeba výfukových plynů vznětových motorů',
		'ISOBUS.DDI.32': 'Skutečný objem na hmotnostní dávku',
		'ISOBUS.DDI.320': 'Poslední načtená hmotnost',
		'ISOBUS.DDI.321': 'Poslední vyložená hmotnost',
		'ISOBUS.DDI.322': 'Identifikační číslo nákladu',
		'ISOBUS.DDI.323': 'Identifikační číslo vykládky',
		'ISOBUS.DDI.324': 'Celkový čas zapojení vrtulníku',
		'ISOBUS.DDI.325': 'Celkový objem aplikace za celou dobu životnosti',
		'ISOBUS.DDI.326': 'Nastavená rychlost hlavičky',
		'ISOBUS.DDI.327': 'Skutečná rychlost hlavičky',
		'ISOBUS.DDI.328': 'Minimální rychlost hlavičky',
		'ISOBUS.DDI.329': 'Maximální rychlost hlavičky',
		'ISOBUS.DDI.33': 'Výchozí objem na hmotnostní dávku',
		'ISOBUS.DDI.330': 'Nastavená hodnota Otáčky řezacího bubnu',
		'ISOBUS.DDI.331': 'Skutečné otáčky řezacího bubnu',
		'ISOBUS.DDI.332': 'Minimální otáčky řezacího bubnu',
		'ISOBUS.DDI.333': 'Maximální rychlost řezacího bubnu',
		'ISOBUS.DDI.334': 'Provozní hodiny od posledního ostření',
		'ISOBUS.DDI.335': 'Hodiny předního vývodového hřídele',
		'ISOBUS.DDI.336': 'Počet hodin zadního vývodového hřídele',
		'ISOBUS.DDI.337': 'Doživotní počet hodin předního vývodového hřídele',
		'ISOBUS.DDI.338': 'Doživotní počet hodin zadního vývodového hřídele',
		'ISOBUS.DDI.339': 'Efektivní celková doba načítání',
		'ISOBUS.DDI.34': 'Minimální objem na hmotnostní dávku',
		'ISOBUS.DDI.340': 'Efektivní celková doba vykládky',
		'ISOBUS.DDI.341': 'Nastavená hodnota Mezera mezi zrny a krekry',
		'ISOBUS.DDI.342': 'Skutečná mezera mezi obilnými zrny a krekry',
		'ISOBUS.DDI.343': 'Minimální mezera mezi zrny a krekry',
		'ISOBUS.DDI.344': 'Maximální mezera mezi krekry obilných zrn',
		'ISOBUS.DDI.345': 'Nastavená šířka pokosu',
		'ISOBUS.DDI.346': 'Skutečná šířka pokosu',
		'ISOBUS.DDI.347': 'Minimální šířka pokosu',
		'ISOBUS.DDI.348': 'Maximální šířka pokosu',
		'ISOBUS.DDI.349': 'Snížení úletu trysek',
		'ISOBUS.DDI.35': 'Maximální objem na hmotnostní dávku',
		'ISOBUS.DDI.350': 'Funkce nebo provozní technika',
		'ISOBUS.DDI.351': 'Aplikace Celková hmotnost',
		'ISOBUS.DDI.352': 'Anwendung Gesamtmasse',
		'ISOBUS.DDI.353': 'Celková aplikace dusíku',
		'ISOBUS.DDI.354': 'Celková aplikace amoniaku',
		'ISOBUS.DDI.355': 'Celková aplikace fosforu',
		'ISOBUS.DDI.356': 'Celková aplikace draslíku',
		'ISOBUS.DDI.357': 'Celková dávka sušiny',
		'ISOBUS.DDI.358': 'Průměrná hmotnost suchého výnosu za čas',
		'ISOBUS.DDI.359': 'Průměrná hmotnost suchého výnosu na plochu',
		'ISOBUS.DDI.36': 'Nastavený objem za čas Aplikační rychlost',
		'ISOBUS.DDI.360': 'Velikost posledního balíku',
		'ISOBUS.DDI.361': 'Hustota posledního balíku',
		'ISOBUS.DDI.362': 'Celková délka balíku',
		'ISOBUS.DDI.363': 'Poslední balík suché hmoty',
		'ISOBUS.DDI.364': 'Skutečná velikost vloček',
		'ISOBUS.DDI.365': 'Nastavení přítlaku',
		'ISOBUS.DDI.366': 'Skutečný přítlak',
		'ISOBUS.DDI.367': 'Stav přepisu zkráceného oddílu (1-16)',
		'ISOBUS.DDI.368': 'Stav přepisu zkráceného oddílu (17-32)',
		'ISOBUS.DDI.369': 'Stav přepisu zkráceného oddílu(33-48)',
		'ISOBUS.DDI.37': 'Skutečný objem za časovou aplikační dávku',
		'ISOBUS.DDI.370': 'Stav přepisu zkráceného oddílu (49-64)',
		'ISOBUS.DDI.371': 'Stav přepisu zkráceného oddílu (65-80)',
		'ISOBUS.DDI.372': 'Stav přepisu zkráceného oddílu (81-96)',
		'ISOBUS.DDI.373': 'Stav přepisu zkráceného oddílu (97-112)',
		'ISOBUS.DDI.374': 'Stav přepisu zkráceného oddílu (113-128)',
		'ISOBUS.DDI.375': 'Stav přepisu zkráceného oddílu (129-144)',
		'ISOBUS.DDI.376': 'Stav přepisu zkráceného oddílu (145-160)',
		'ISOBUS.DDI.377': 'Stav přepisu zkráceného oddílu (161-176)',
		'ISOBUS.DDI.378': 'Stav přepisu zkráceného oddílu(177-192)',
		'ISOBUS.DDI.379': 'Stav přepisu zkráceného oddílu (193-208)',
		'ISOBUS.DDI.38': 'Výchozí objem za časovou aplikační dávku',
		'ISOBUS.DDI.380': 'Zkrácený stav přepisu sekcí (209-224)',
		'ISOBUS.DDI.381': 'Zkrácený stav přepisu sekcí (225-240)',
		'ISOBUS.DDI.382': 'Zkrácený stav přepisu sekcí (241-256)',
		'ISOBUS.DDI.383': 'Zdánlivý směr větru',
		'ISOBUS.DDI.384': 'Zdánlivá rychlost větru',
		'ISOBUS.DDI.385': 'Atmosférický tlak MSL',
		'ISOBUS.DDI.386': 'Skutečný atmosférický tlak',
		'ISOBUS.DDI.387': 'Celkový počet otáček ve zlomkových otáčkách',
		'ISOBUS.DDI.388': 'Celkový počet otáček v kompletních otáčkách',
		'ISOBUS.DDI.389': 'Otáčky nastavené hodnoty zadané jako počet za čas',
		'ISOBUS.DDI.39': 'Minimální objem za časovou aplikační dávku',
		'ISOBUS.DDI.390': 'Skutečné otáčky za čas',
		'ISOBUS.DDI.391': 'Výchozí otáčky za čas',
		'ISOBUS.DDI.392': 'Minimální počet otáček za čas',
		'ISOBUS.DDI.393': 'Skutečný obsah nádrže s výfukovými plyny vznětových motorů',
		'ISOBUS.DDI.394': 'Skutečný obsah palivové nádrže',
		'ISOBUS.DDI.395': 'Skutečný obsah nádrže s výfukovými plyny vznětových motorů',
		'ISOBUS.DDI.396': 'Nastavená rychlost',
		'ISOBUS.DDI.397': 'Skutečná rychlost',
		'ISOBUS.DDI.398': 'Minimální rychlost',
		'ISOBUS.DDI.399': 'Maximální rychlost',
		'ISOBUS.DDI.4': 'Minimální objem na plochu',
		'ISOBUS.DDI.40': 'Maximální objem za časovou aplikační dávku',
		'ISOBUS.DDI.400': 'Zdroj rychlosti',
		'ISOBUS.DDI.401': 'Skutečná aplikace dusíku',
		'ISOBUS.DDI.402': 'Skutečná aplikace amoniaku',
		'ISOBUS.DDI.403': 'Skutečné použití fosforu',
		'ISOBUS.DDI.404': 'Skutečná aplikace draslíku',
		'ISOBUS.DDI.405': 'Skutečné použití sušiny',
		'ISOBUS.DDI.406': 'Skutečný obsah bílkovin',
		'ISOBUS.DDI.407': 'Průměrný obsah bílkovin',
		'ISOBUS.DDI.408': 'Průměrná kontaminace plodin',
		'ISOBUS.DDI.409': 'Celková spotřeba výfukových plynů',
		'ISOBUS.DDI.41': 'Nastavená hmotnost za čas Aplikační dávka',
		'ISOBUS.DDI.410': 'Výfukové plyny z dieselových motorů Spotřeba za čas',
		'ISOBUS.DDI.411': 'Spotřeba výfukových plynů na plochu',
		'ISOBUS.DDI.412': 'Spotřeba výfukových plynů za celou dobu životnosti',
		'ISOBUS.DDI.413': 'Průměrná spotřeba výfukových plynů za dobu životnosti',
		'ISOBUS.DDI.414': 'Průměrná celoživotní spotřeba výfukových plynů na plochu',
		'ISOBUS.DDI.415': 'Skutečné procento zpěvnění osiva',
		'ISOBUS.DDI.416': 'Průměrné procento zpěvnosti semen',
		'ISOBUS.DDI.417': 'Skutečné procento vynechání osiva',
		'ISOBUS.DDI.418': 'Průměrné procento vynechání osiva',
		'ISOBUS.DDI.419': 'Skutečný procentuální podíl osiva',
		'ISOBUS.DDI.42': 'Skutečná hmotnost za časovou aplikační dávku',
		'ISOBUS.DDI.420': 'Průměrné procento násobku osiva',
		'ISOBUS.DDI.421': 'Skutečná odchylka rozteče osiva',
		'ISOBUS.DDI.422': 'Průměrná odchylka rozteče semen',
		'ISOBUS.DDI.423': 'Skutečný variační koeficient rozteče osiva v procentech',
		'ISOBUS.DDI.424': 'Průměrný variační koeficient rozteče osiva v procentech',
		'ISOBUS.DDI.425': 'Nastavená hodnota Maximální povolená odchylka rozteče semen',
		'ISOBUS.DDI.426': 'Nastavená hodnota přítlaku jako síla',
		'ISOBUS.DDI.427': 'Skutečná přítlačná síla jako síla',
		'ISOBUS.DDI.428': 'Naložená celková hmotnost',
		'ISOBUS.DDI.429': 'Celková hmotnost v nenaloženém stavu',
		'ISOBUS.DDI.43': 'Výchozí hmotnostní dávka na čas',
		'ISOBUS.DDI.430': 'Celková hmotnost po celou dobu životnosti',
		'ISOBUS.DDI.431': 'Životnost Celková hmotnost bez zatížení',
		'ISOBUS.DDI.432': 'Nastavená dávka dusíku',
		'ISOBUS.DDI.433': 'Skutečná dávka dusíku',
		'ISOBUS.DDI.434': 'Minimální dávka dusíku',
		'ISOBUS.DDI.435': 'Maximální dávka dusíku',
		'ISOBUS.DDI.436': 'Nastavená aplikační dávka amoniaku',
		'ISOBUS.DDI.437': 'Skutečná aplikační dávka amoniaku',
		'ISOBUS.DDI.438': 'Minimální aplikační dávka amoniaku',
		'ISOBUS.DDI.439': 'Maximální aplikační dávka amoniaku',
		'ISOBUS.DDI.44': 'Minimální hmotnost na časovou aplikační dávku',
		'ISOBUS.DDI.440': 'Nastavená aplikační dávka fosforu',
		'ISOBUS.DDI.441': 'Skutečná aplikační dávka fosforu',
		'ISOBUS.DDI.442': 'Minimální dávka fosforu',
		'ISOBUS.DDI.443': 'Maximální dávka fosforu',
		'ISOBUS.DDI.444': 'Nastavená aplikační dávka draslíku',
		'ISOBUS.DDI.445': 'Skutečná aplikační dávka draslíku',
		'ISOBUS.DDI.446': 'Minimální dávka draslíku',
		'ISOBUS.DDI.447': 'Maximální dávka draslíku',
		'ISOBUS.DDI.448': 'Nastavená aplikační dávka sušiny',
		'ISOBUS.DDI.449': 'Skutečná aplikační dávka sušiny',
		'ISOBUS.DDI.45': 'Maximální hmotnost za časovou aplikační dávku',
		'ISOBUS.DDI.450': 'Minimální dávka sušiny',
		'ISOBUS.DDI.451': 'Maximální dávka sušiny',
		'ISOBUS.DDI.452': 'Naložený celkový objem',
		'ISOBUS.DDI.453': 'Vyložený celkový objem',
		'ISOBUS.DDI.454': 'Celkové zatížení po dobu životnosti',
		'ISOBUS.DDI.455': 'Celkový objem po celou dobu životnosti bez zatížení',
		'ISOBUS.DDI.456': 'Poslední načtený svazek',
		'ISOBUS.DDI.457': 'Poslední vyložený objem',
		'ISOBUS.DDI.458': 'Načtený celkový počet',
		'ISOBUS.DDI.459': 'Vyloženo Celkový počet',
		'ISOBUS.DDI.46': 'Nastavená hodnota Počet za čas Aplikační rychlost',
		'ISOBUS.DDI.460': 'Celkový počet načtených položek za celou dobu životnosti',
		'ISOBUS.DDI.461': 'Životnost Bez zatížení Celkový počet',
		'ISOBUS.DDI.462': 'Poslední načtený počet',
		'ISOBUS.DDI.463': 'Poslední vyložený počet',
		'ISOBUS.DDI.464': 'Počítadlo zásilek',
		'ISOBUS.DDI.465': 'Doživotní počítadlo zásilek',
		'ISOBUS.DDI.466': 'Skutečný relativní úhel konektoru',
		'ISOBUS.DDI.467': 'Skutečný procentuální obsah',
		'ISOBUS.DDI.468': 'Půda Sníh/zmrzlá půda',
		'ISOBUS.DDI.469': 'Odhadovaný stav půdní vody',
		'ISOBUS.DDI.47': 'Skutečný počet za čas Aplikační sazba',
		'ISOBUS.DDI.470': 'Zhutnění půdy',
		'ISOBUS.DDI.472': 'Nastavená délka řezu',
		'ISOBUS.DDI.473': 'Minimální délka řezu',
		'ISOBUS.DDI.474': 'Maximální délka řezu',
		'ISOBUS.DDI.475': 'Nastavení hydraulického tlaku balíků',
		'ISOBUS.DDI.476': 'Minimální hydraulický tlak v balících',
		'ISOBUS.DDI.477': 'Maximální hydraulický tlak balíků',
		'ISOBUS.DDI.478': 'Nastavená velikost vloček',
		'ISOBUS.DDI.479': 'Minimální velikost vloček',
		'ISOBUS.DDI.48': 'Výchozí počet za čas Aplikační dávka',
		'ISOBUS.DDI.480': 'Maximální velikost vloček',
		'ISOBUS.DDI.481': 'Nastavená hodnota Počet dílčích balíků',
		'ISOBUS.DDI.482': 'Poslední balík Počet podbalíků',
		'ISOBUS.DDI.483': 'Nastavená hodnota otáček motoru',
		'ISOBUS.DDI.484': 'Skutečné otáčky motoru',
		'ISOBUS.DDI.485': 'Minimální otáčky motoru',
		'ISOBUS.DDI.486': 'Maximální otáčky motoru',
		'ISOBUS.DDI.488': 'Procentuální stav nádrže výfukové kapaliny pro vznětové motory',
		'ISOBUS.DDI.489': 'Maximální obsah nádrže na výfukové plyny',
		'ISOBUS.DDI.49': 'Minimální počet na čas Aplikační dávka',
		'ISOBUS.DDI.490': 'Maximální obsah palivové nádrže',
		'ISOBUS.DDI.491': 'Úroveň procentuálního podílu paliva',
		'ISOBUS.DDI.492': 'Celkový počet motohodin',
		'ISOBUS.DDI.493': 'Počet motohodin za celou dobu životnosti',
		'ISOBUS.DDI.494': 'ID posledního partnera události (bajt 1-4)',
		'ISOBUS.DDI.495': 'ID posledního partnera události (bajt 5-8)',
		'ISOBUS.DDI.496': 'ID posledního partnera události (bajt 9-12)',
		'ISOBUS.DDI.497': 'ID posledního partnera události (bajt 13-16)',
		'ISOBUS.DDI.498': 'Poslední událost Partner ID Typ',
		'ISOBUS.DDI.499': 'Poslední událost ID partnera ID výrobce ID kód',
		'ISOBUS.DDI.5': 'Maximální objem na plochu',
		'ISOBUS.DDI.50': 'Maximální počet za čas Aplikační dávka',
		'ISOBUS.DDI.500': 'ID posledního partnera události Třída zařízení',
		'ISOBUS.DDI.501': 'Nastavená hodnota točivého momentu motoru',
		'ISOBUS.DDI.502': 'Skutečný točivý moment motoru',
		'ISOBUS.DDI.503': 'Minimální točivý moment motoru',
		'ISOBUS.DDI.504': 'Maximální točivý moment motoru',
		'ISOBUS.DDI.505': 'Úroveň řízení tramvajové trati',
		'ISOBUS.DDI.506': 'Nastavená úroveň regulace Tramline',
		'ISOBUS.DDI.507': 'Pořadové číslo tramvajové trati',
		'ISOBUS.DDI.508': 'Jedinečné ID vodicího řádku A-B',
		'ISOBUS.DDI.509': 'Skutečné číslo stopy',
		'ISOBUS.DDI.51': 'Nastavená hloubka zpracování půdy',
		'ISOBUS.DDI.510': 'Číslo skladby vpravo',
		'ISOBUS.DDI.511': 'Číslo skladby vlevo',
		'ISOBUS.DDI.512': 'Šířka naváděcí čáry',
		'ISOBUS.DDI.513': 'Odchylka naváděcí čáry',
		'ISOBUS.DDI.514': 'Kvalita GNSS',
		'ISOBUS.DDI.515': 'Stav řízení tramvajové trati',
		'ISOBUS.DDI.516': 'Míra předávkování přípravkem Tramline',
		'ISOBUS.DDI.517': 'Nastavená hodnota Tramline Zhuštěný pracovní stav 1-16',
		'ISOBUS.DDI.518': 'Skutečná tramvajová trať Zkrácený pracovní stav 1-16',
		'ISOBUS.DDI.519': 'Počet posledních balíků za celou dobu životnosti',
		'ISOBUS.DDI.52': 'Skutečná hloubka zpracování půdy',
		'ISOBUS.DDI.520': 'Skutečná výška stříšky',
		'ISOBUS.DDI.521': 'Typ instalace GNSS',
		'ISOBUS.DDI.522': 'Balík motouzu Celkový počet',
		'ISOBUS.DDI.523': 'Balík pletiva Celkový počet',
		'ISOBUS.DDI.524': 'Balík motouzu na celý život Celkový počet',
		'ISOBUS.DDI.525': 'Celkový počet balíků sítě Lifetime Mesh Bale',
		'ISOBUS.DDI.526': 'Skutečná teplota chladicí kapaliny',
		'ISOBUS.DDI.528': 'Kapacita posledního balíku',
		'ISOBUS.DDI.529': 'Nastavení úhlu záběru kypřicího kotouče',
		'ISOBUS.DDI.53': 'Výchozí hloubka zpracování půdy',
		'ISOBUS.DDI.530': 'Skutečný úhel disků pro zpracování půdy',
		'ISOBUS.DDI.531': 'Skutečně použitá konzervační látka na výnosovou hmotnost',
		'ISOBUS.DDI.532': 'Nastavená hodnota Aplikovaná konzervační látka na výtěžkovou hmotnost',
		'ISOBUS.DDI.533': 'Výchozí použitá konzervační látka na výnosovou hmotnost',
		'ISOBUS.DDI.534': 'Minimální množství použitého konzervačního prostředku na výnosovou hmotnost',
		'ISOBUS.DDI.535': 'Maximální množství použitého konzervačního prostředku na výnosovou hmotnost',
		'ISOBUS.DDI.536': 'Celkem použitá konzervační látka',
		'ISOBUS.DDI.537': 'Doživotní konzervační prostředek',
		'ISOBUS.DDI.538': 'Průměrná aplikovaná konzervační látka na výnosovou hmotnost',
		'ISOBUS.DDI.539': 'Skutečný objem nádrže s konzervačním prostředkem',
		'ISOBUS.DDI.54': 'Minimální hloubka zpracování půdy',
		'ISOBUS.DDI.540': 'Skutečná hladina v nádrži s konzervačními látkami',
		'ISOBUS.DDI.541': 'Skutečné otáčky PTO',
		'ISOBUS.DDI.542': 'Nastavená hodnota otáček PTO',
		'ISOBUS.DDI.543': 'Výchozí otáčky vývodového hřídele',
		'ISOBUS.DDI.544': 'Minimální otáčky vývodového hřídele',
		'ISOBUS.DDI.545': 'Maximální otáčky vývodového hřídele',
		'ISOBUS.DDI.546': 'Celkový čas sekání po celou dobu životnosti',
		'ISOBUS.DDI.547': 'Nastavená hodnota zatížení stlačení balíku plunžrem',
		'ISOBUS.DDI.548': 'Skutečné zatížení pístu při stlačování balíků',
		'ISOBUS.DDI.549': 'Poslední balík Průměrné stlačení balíku Zatížení pístu',
		'ISOBUS.DDI.55': 'Maximální hloubka zpracování půdy',
		'ISOBUS.DDI.550': 'Pozemní kryt',
		'ISOBUS.DDI.551': 'Skutečný krouticí moment PTO',
		'ISOBUS.DDI.552': 'Nastavení krouticího momentu PTO',
		'ISOBUS.DDI.553': 'Výchozí krouticí moment PTO',
		'ISOBUS.DDI.554': 'Minimální krouticí moment PTO',
		'ISOBUS.DDI.555': 'Maximální krouticí moment vývodového hřídele',
		'ISOBUS.DDI.556': 'Současné povětrnostní podmínky',
		'ISOBUS.DDI.557': 'Nastavená hodnota elektrického proudu',
		'ISOBUS.DDI.558': 'Skutečný elektrický proud',
		'ISOBUS.DDI.559': 'Minimální elektrický proud',
		'ISOBUS.DDI.56': 'Nastavená hloubka výsevu',
		'ISOBUS.DDI.560': 'Maximální elektrický proud',
		'ISOBUS.DDI.561': 'Výchozí elektrický proud',
		'ISOBUS.DDI.562': 'Nastavené napětí',
		'ISOBUS.DDI.563': 'Výchozí napětí',
		'ISOBUS.DDI.564': 'Skutečné napětí',
		'ISOBUS.DDI.565': 'Minimální napětí',
		'ISOBUS.DDI.566': 'Maximální napětí',
		'ISOBUS.DDI.567': 'Skutečný elektrický odpor',
		'ISOBUS.DDI.568': 'Nastavená hodnota elektrického výkonu',
		'ISOBUS.DDI.569': 'Skutečný elektrický výkon',
		'ISOBUS.DDI.57': 'Skutečná hloubka výsevu',
		'ISOBUS.DDI.570': 'Výchozí elektrická energie',
		'ISOBUS.DDI.571': 'Maximální elektrický výkon',
		'ISOBUS.DDI.572': 'Minimální elektrický výkon',
		'ISOBUS.DDI.573': 'Celková elektrická energie',
		'ISOBUS.DDI.574': 'Nastavená elektrická energie na plochu',
		'ISOBUS.DDI.575': 'Skutečná spotřeba elektrické energie na plochu',
		'ISOBUS.DDI.576': 'Maximální rychlost aplikace elektrické energie na plochu',
		'ISOBUS.DDI.577': 'Minimální množství elektrické energie na plochu',
		'ISOBUS.DDI.578': 'Nastavená teplota',
		'ISOBUS.DDI.579': 'Skutečná teplota',
		'ISOBUS.DDI.58': 'Výchozí hloubka výsevu',
		'ISOBUS.DDI.580': 'Minimální teplota',
		'ISOBUS.DDI.581': 'Maximální teplota',
		'ISOBUS.DDI.582': 'Výchozí teplota',
		'ISOBUS.DDI.583': 'Nastavená frekvence',
		'ISOBUS.DDI.584': 'Skutečná frekvence',
		'ISOBUS.DDI.585': 'Minimální frekvence',
		'ISOBUS.DDI.586': 'Maximální frekvence',
		'ISOBUS.DDI.587': 'Předchozí srážky',
		'ISOBUS.DDI.588': 'Nastavený objem na plochu aplikační rychlost',
		'ISOBUS.DDI.589': 'Skutečný objem na plochu',
		'ISOBUS.DDI.59': 'Minimální hloubka výsevu',
		'ISOBUS.DDI.590': 'Minimální objem na plochu',
		'ISOBUS.DDI.591': 'Maximální objem na plochu',
		'ISOBUS.DDI.592': 'Výchozí aplikační dávka na plochu',
		'ISOBUS.DDI.593': 'Typ trakce',
		'ISOBUS.DDI.594': 'Typ řízení',
		'ISOBUS.DDI.595': 'Režim stroje',
		'ISOBUS.DDI.596': 'Stav krytu nákladového prostoru',
		'ISOBUS.DDI.597': 'Celková vzdálenost',
		'ISOBUS.DDI.598': 'Celková vzdálenost za celou dobu životnosti',
		'ISOBUS.DDI.599': 'Pole celkové vzdálenosti',
		'ISOBUS.DDI.6': 'Nastavená hmotnost na plochu Aplikační dávka',
		'ISOBUS.DDI.60': 'Maximální hloubka výsevu',
		'ISOBUS.DDI.600': 'Pole celkové vzdálenosti za celou dobu životnosti',
		'ISOBUS.DDI.601': 'Celková vzdálenost Ulice',
		'ISOBUS.DDI.602': 'Životnost Celková vzdálenost Ulice',
		'ISOBUS.DDI.603': 'Skutečný zkrácený pracovní stav tramvajové trati (17-32)',
		'ISOBUS.DDI.604': 'Skutečný zkrácený pracovní stav tramvajové trati (33-48)',
		'ISOBUS.DDI.605': 'Skutečný zkrácený pracovní stav tramvajové trati (49-64)',
		'ISOBUS.DDI.606': 'Skutečný zkrácený pracovní stav tramvajové trati (65-80)',
		'ISOBUS.DDI.607': 'Skutečný zkrácený pracovní stav tramvajové trati (81-96)',
		'ISOBUS.DDI.608': 'Skutečný zkrácený pracovní stav tramvajové trati (97-112)',
		'ISOBUS.DDI.609': 'Skutečný zkrácený pracovní stav tramvajové trati (113-128)',
		'ISOBUS.DDI.61': 'Nastavená pracovní výška',
		'ISOBUS.DDI.610': 'Skutečný zkrácený pracovní stav tramvajové trati (129-144)',
		'ISOBUS.DDI.611': 'Skutečný zkrácený pracovní stav tramvajové trati (145-160)',
		'ISOBUS.DDI.612': 'Skutečný zkrácený pracovní stav tramvajové trati (161-176)',
		'ISOBUS.DDI.613': 'Skutečný zkrácený pracovní stav tramvajové trati (177-192)',
		'ISOBUS.DDI.614': 'Skutečný zkrácený pracovní stav tramvajové trati (193-208)',
		'ISOBUS.DDI.615': 'Skutečný zkrácený pracovní stav tramvajové trati (209-224)',
		'ISOBUS.DDI.616': 'Skutečný zkrácený pracovní stav tramvajové trati (225-240)',
		'ISOBUS.DDI.617': 'Skutečný zkrácený pracovní stav tramvajové trati (241-256)',
		'ISOBUS.DDI.618': 'Nastavená hodnota Tramline Kondenzovaný pracovní stav (17-32)',
		'ISOBUS.DDI.619': 'Nastavená tramvajová trať Zhuštěný pracovní stav (33-48)',
		'ISOBUS.DDI.62': 'Skutečná pracovní výška',
		'ISOBUS.DDI.620': 'Nastavení Tramvajová linka Zhuštěný pracovní stav (49-64)',
		'ISOBUS.DDI.621': 'Nastavená hodnota Tramline Kondenzovaný pracovní stav (65-80)',
		'ISOBUS.DDI.622': 'Nastavená hodnota Tramline Kondenzovaný pracovní stav (81-96)',
		'ISOBUS.DDI.623': 'Nastavení Tramvajová linka Zhuštěný pracovní stav (97-112)',
		'ISOBUS.DDI.624': 'Nastavení Tramvajová linka Zhuštěný pracovní stav (113-128)',
		'ISOBUS.DDI.625': 'Nastavená hodnota Tramline Kondenzovaný pracovní stav (129-144)',
		'ISOBUS.DDI.626': 'Nastavená hodnota Tramline Kondenzovaný pracovní stav (145-160)',
		'ISOBUS.DDI.627': 'Nastavená hodnota Tramline Kondenzovaný pracovní stav (161-176)',
		'ISOBUS.DDI.628': 'Nastavená tramvajová trať Kondenzovaný pracovní stav (177-192)',
		'ISOBUS.DDI.629': 'Nastavená tramvajová trať Kondenzovaný pracovní stav (193-208)',
		'ISOBUS.DDI.63': 'Výchozí pracovní výška',
		'ISOBUS.DDI.630': 'Nastavená tramvajová trať Kondenzovaný pracovní stav (209-224)',
		'ISOBUS.DDI.631': 'Nastavená hodnota Tramline Kondenzovaný pracovní stav (225-240)',
		'ISOBUS.DDI.632': 'Nastavená tramvajová trať Kondenzovaný pracovní stav (241-256)',
		'ISOBUS.DDI.634': 'Skutečný objem na vzdálenost',
		'ISOBUS.DDI.635': 'Výchozí objem na vzdálenost',
		'ISOBUS.DDI.636': 'Minimální objem na vzdálenost',
		'ISOBUS.DDI.637': 'Maximální objem na vzdálenost',
		'ISOBUS.DDI.638': 'Nastavený tlak v pneumatikách',
		'ISOBUS.DDI.639': 'Skutečný tlak v pneumatikách',
		'ISOBUS.DDI.64': 'Minimální pracovní výška',
		'ISOBUS.DDI.640': 'Výchozí tlak v pneumatikách',
		'ISOBUS.DDI.641': 'Minimální tlak v pneumatikách',
		'ISOBUS.DDI.642': 'Maximální tlak v pneumatikách',
		'ISOBUS.DDI.643': 'Skutečná teplota pneumatik',
		'ISOBUS.DDI.65': 'Maximální pracovní výška',
		'ISOBUS.DDI.66': 'Pracovní šířka nastavené hodnoty',
		'ISOBUS.DDI.67': 'Skutečná pracovní šířka',
		'ISOBUS.DDI.68': 'Výchozí pracovní šířka',
		'ISOBUS.DDI.69': 'Minimální pracovní šířka',
		'ISOBUS.DDI.7': 'Skutečná hmotnost na plochu',
		'ISOBUS.DDI.70': 'Maximální pracovní šířka',
		'ISOBUS.DDI.71': 'Nastavená hodnota Objem Obsah',
		'ISOBUS.DDI.72': 'Skutečný objem Obsah',
		'ISOBUS.DDI.73': 'Maximální objemový obsah',
		'ISOBUS.DDI.74': 'Nastavená hodnota Hmotnostní obsah',
		'ISOBUS.DDI.75': 'Skutečný hmotnostní obsah',
		'ISOBUS.DDI.76': 'Maximální hmotnostní obsah',
		'ISOBUS.DDI.77': 'Obsah počítadla nastavených hodnot',
		'ISOBUS.DDI.78': 'Skutečný počet Obsah',
		'ISOBUS.DDI.79': 'Maximální počet Obsah',
		'ISOBUS.DDI.8': 'Výchozí hmotnostní dávka na plochu',
		'ISOBUS.DDI.80': 'Aplikace Celkový objem',
		'ISOBUS.DDI.81': 'Aplikace Celková hmotnost',
		'ISOBUS.DDI.82': 'Aplikace Celkový počet',
		'ISOBUS.DDI.83': 'Objem na plochu Výnos',
		'ISOBUS.DDI.84': 'Hmotnost na plochu Výnos',
		'ISOBUS.DDI.85': 'Počet na plochu Výnos',
		'ISOBUS.DDI.86': 'Objem za čas Výnos',
		'ISOBUS.DDI.87': 'Hmotnost za čas Výnos',
		'ISOBUS.DDI.88': 'Počet za čas Výnos',
		'ISOBUS.DDI.89': 'Výnos Celkový objem',
		'ISOBUS.DDI.9': 'Minimální hmotnostní dávka na plochu',
		'ISOBUS.DDI.90': 'Výnos Celková hmotnost',
		'ISOBUS.DDI.91': 'Výnos Celkový počet',
		'ISOBUS.DDI.92': 'Objem na plochu Ztráta na plodinách',
		'ISOBUS.DDI.93': 'Hmotnost na plochu Ztráta plodin',
		'ISOBUS.DDI.94': 'Počet na plochu Ztráta plodin',
		'ISOBUS.DDI.95': 'Objem za čas Ztráta plodin',
		'ISOBUS.DDI.96': 'Hmotnost za čas Ztráta úrody',
		'ISOBUS.DDI.97': 'Počet za čas Ztráta plodin',
		'ISOBUS.DDI.98': 'Procento ztráty úrody',
		'ISOBUS.DDI.99': 'Vlhkost plodin',
		'ISOBUS.DEVICE_CLASS.0': 'Není specifikováno',
		'ISOBUS.DEVICE_CLASS.1': 'Traktor',
		'ISOBUS.DEVICE_CLASS.10': 'Zavlažování',
		'ISOBUS.DEVICE_CLASS.11': 'Přeprava/přívěs',
		'ISOBUS.DEVICE_CLASS.12': 'Provoz na zemědělském dvoře',
		'ISOBUS.DEVICE_CLASS.13': 'Napájená pomocná zařízení',
		'ISOBUS.DEVICE_CLASS.14': 'Speciální plodiny',
		'ISOBUS.DEVICE_CLASS.15': 'Zemní práce',
		'ISOBUS.DEVICE_CLASS.16': 'Smykadlo',
		'ISOBUS.DEVICE_CLASS.17': 'Senzorové systémy',
		'ISOBUS.DEVICE_CLASS.18': ' - ',
		'ISOBUS.DEVICE_CLASS.19': 'Těžaři dřeva',
		'ISOBUS.DEVICE_CLASS.2': 'Zpracování půdy',
		'ISOBUS.DEVICE_CLASS.20': 'Soil processing',
		'ISOBUS.DEVICE_CLASS.21': 'Nakladače dřeva',
		'ISOBUS.DEVICE_CLASS.22': 'Stroje na zpracování dřeva',
		'ISOBUS.DEVICE_CLASS.23': 'Mulčovače',
		'ISOBUS.DEVICE_CLASS.24': 'Nutzfahrzeuge',
		'ISOBUS.DEVICE_CLASS.25': 'Gülle-/Düngerapplikatoren',
		'ISOBUS.DEVICE_CLASS.26': 'Beschicker/Mischer',
		'ISOBUS.DEVICE_CLASS.27': 'Sekundäre Bodenbearbeitung',
		'ISOBUS.DEVICE_CLASS.3': 'Sekundäre Bodenbearbeitung',
		'ISOBUS.DEVICE_CLASS.4': 'Pflanzmaschinen/Sämaschinen',
		'ISOBUS.DEVICE_CLASS.5': 'Hnojiva',
		'ISOBUS.DEVICE_CLASS.6': 'Postřikovače',
		'ISOBUS.DEVICE_CLASS.7': 'Harvestery',
		'ISOBUS.DEVICE_CLASS.8': 'Sklízeče kořenů',
		'ISOBUS.DEVICE_CLASS.9': 'Pícniny',
		'JOB.ARCHIVE.QUESTION': 'Opravdu chcete tuto práci archivovat?',
		'JOB.ARCHIVE.SUCCESS': 'Práce bude archivována',
		'JOB.CAN_NOT_BE_DISPLAYED_COMPLETELY': 'Úlohu nelze zobrazit úplně. Všechny výše uvedené informace mohou být zastaralé a budou přepočítány.',
		'JOB.CURRENT_STATUS': 'Aktuální stav',
		'JOB.DELETE.QUESTION': 'Opravdu chcete tuto práci smazat?',
		'JOB.DELETE.SUCCESS': 'Práce bude smazána',
		'JOB.DETAILS': 'Podrobnosti o práci',
		'JOB.DRIVER_IMPLEMENT': 'Odstranění nebo změna ovladače/implementace.',
		'JOB.EDIT': 'Upravit práci',
		'JOB.REGENERATE': 'Regenerovat úlohu',
		'JOB.REGENERATE.DRIVER': 'Aktualizace dat řidiče',
		'JOB.REGENERATE.FIELDS': 'Aktualizace dat pole',
		'JOB.REGENERATE.IMPLEMENT': 'Aktualizace údajů o implementaci',
		'JOB.REGENERATE.INTRO': 'Pokud došlo ke změně fakturačních údajů u strojů, nářadí nebo řidičů, lze je rovněž aktualizovat.',
		'JOB.REGENERATE.LOCATIONS': 'Aktualizace údajů o poloze',
		'JOB.REGENERATE.MACHINE': 'Aktualizace dat stroje',
		'JOB.REGENERATE.QUESTION': 'Které údaje se aktualizují?',
		'JOB.REGENERATE.SUCCESS': 'Job bude regenerován',
		'JOB.SPLIT': 'Rozdělená práce',
		'JOB.SPLIT.ADD_SPLIT_TIME': 'Přidání rozděleného času',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO': 'Pro nastavení s přesností na sekundy lze posuvník času ovládat také pomocí tlačítek se šipkami.',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO2': 'Přidejte čas(y) pro rozdělení úlohy.',
		'JOB.SPLIT.NO_CHANGE': 'Žádná změna zaměstnání',
		'JOB.SPLIT.NO_SPLITS': 'Pro rozdělení není vybrán žádný čas.',
		'JOB.UPDATE': 'Aktualizovat úlohy',
		'JOB.WAITING_TIME_UNTIL_READY': 'V závislosti na aktuálním stavu může trvat několik minut, než bude možné úlohu zcela zobrazit.',
		'JOBS': 'Pracovní záznamy',
		'JOBS.ALL': 'Všechna pracovní místa',
		'JOBS.ARCHIVE.PARTIAL': 'Některé úlohy jsou archivovány.',
		'JOBS.ARCHIVE.QUESTION': 'Opravdu chcete vybrané úlohy archivovat?',
		'JOBS.ARCHIVE.SUCCESS': 'Pracovní místa budou archivována',
		'JOBS.CREATE_TASK': 'Vytvořit úkol',
		'JOBS.DELETE.QUESTION': 'Opravdu chcete odstranit vybrané úlohy? Všechna data úloh budou nevratně odstraněna.',
		'JOBS.DELETE.SUCCESS': 'Práce budou vymazány',
		'JOBS.DELETED.FAILURE': 'Některé úlohy nebylo možné odstranit.',
		'JOBS.EDIT': 'Úprava pracovních míst',
		'JOBS.EDIT.SUCCESS': 'Pracovní místa se budou upravovat',
		'JOBS.IN_TASK': 'Nabídky práce v úkolech',
		'JOBS.MERGE.SUCCESS': 'Pracovní místa budou sloučena',
		'JOBS.MERGING': 'Sloučení úloh',
		'JOBS.NO': 'Žádná pracovní místa',
		'JOBS.NOT_SELECTED': 'Nebyla vybrána žádná pracovní místa',
		'JOBS.REGENERATE': 'Regenerace pracovních míst',
		'JOBS.REGENERATE.SUCCESS': 'Pracovní místa budou obnovena',
		'JOBS.SELECTED': 'Vybraná pracovní místa',
		'JOBS.TASK_CREATED': 'Úspěšně vytvořená úloha',
		'JOBS.UPDATE.SUCCESS': 'Pracovní místa budou aktualizována',
		'JOBS.WITHOUT_TASK': 'Pracovní místa bez úkolu',
		'JOBS.WITH_TASK': 'Nabídky práce v úkolu',
		'KILOMETERS': 'Kilometry',
		'LANGUAGE': 'Jazyk',
		'LANGUAGE.ADD': 'Přidat jazyk',
		'LANGUAGE.CODE': 'Kód jazyka',
		'LANGUAGE.DEFAULT': 'Výchozí jazyk',
		'LASTNAME': 'Příjmení',
		'LAST_ONLINE': 'Naposledy online',
		'LAST_UPDATED': 'Poslední aktualizace',
		'LATITUDE': 'Zeměpisná šířka',
		'LOAD.MORE': 'Načíst více',
		'LOADS': 'Loads',
		'LOCATION': 'Město',
		'LOCATION.ADD': 'Přidat umístění',
		'LOCATION.ADD.SUCCESS': 'Úspěšně přidané umístění',
		'LOCATION.DEACTIVATE.QUESTION': 'Opravdu chcete deaktivovat umístění?',
		'LOCATION.DEACTIVATE.SUCCESS': 'Umístění bylo úspěšně deaktivováno',
		'LOCATION.DELETE.QUESTION': 'Opravdu chcete odstranit umístění?',
		'LOCATION.DELETE.SUCCESS': 'Umístění bylo úspěšně odstraněno',
		'LOCATION.DETAILS': 'Podrobnosti o umístění',
		'LOCATION.DRAW.START': 'Označte místo v mapě!',
		'LOCATION.EDIT.SUCCESS': 'Úspěšně upravená poloha',
		'LOCATIONS': 'Místa',
		'LOCATIONS.ALL': 'Všechna místa',
		'LOCATIONS.DEACTIVATE.FAILURE': 'Některá místa nebylo možné deaktivovat.',
		'LOCATIONS.DEACTIVATE.QUESTION': 'Opravdu chcete místa deaktivovat?',
		'LOCATIONS.DEACTIVATE.SUCCESS': 'Lokality byly úspěšně deaktivovány',
		'LOCATIONS.DELETE.FAILURE': 'Některá místa nebylo možné vymazat.',
		'LOCATIONS.DELETE.QUESTION': 'Opravdu chcete odstranit vybraná místa?',
		'LOCATIONS.DELETE.SUCCESS': 'Místa byly úspěšně odstraněny',
		'LOCATIONS.NO': 'Žádná místa',
		'LOCATIONS.NOT_SELECTED': 'Žádná vybraná místa',
		'LOCATIONS.REACTIVATE.FAILURE': 'Některá místa nebylo možné znovu aktivovat.',
		'LOCATIONS.REACTIVATE.QUESTION': 'Opravdu chcete vybraná místa znovu aktivovat?',
		'LOCATIONS.REACTIVATE.SUCCESS': 'Úspěšně reaktivované lokality',
		'LOCATIONS.SELECTED': 'Vybrané Místa',
		'LOG': 'Protokol zpráv',
		'LOGIN': 'Přihlášení',
		'LOGIN.NOT_UNLOCKED_YET': 'Ještě není odemčeno?',
		'LOGIN.NO_ACCOUNT_YET': 'Ještě nemáte účet?',
		'LOGIN.PASSWORD_FORGOTTEN': 'Zapomněli jste heslo?',
		'LOGIN.REGISTER': 'Registrace',
		'LOGIN.REMEMBER_PASSWORD': 'Zapamatování hesla',
		'LOGIN.UNLOCK': 'Odemknutí stránky',
		'LOG_OUT': 'Odhlášení',
		'LONGITUDE': 'Zeměpisná délka',
		'LOST_PASSWORD.CHANGE_PASSWORD': 'Změna hesla',
		'LOST_PASSWORD.ENTER_ACTIVATION': 'Zadejte aktivační kód, který jste obdrželi e-mailem.',
		'LOST_PASSWORD.ENTER_EMAIL_HERE': 'Zde prosím zadejte svůj e-mail.',
		'LOST_PASSWORD.ENTER_VALID_EMAIL': 'Zadejte prosím platnou e-mailovou adresu.',
		'MAC': ' MAC ',
		'MACHINE': 'Stroj',
		'MACHINE.ADD': 'Přidat stroj',
		'MACHINE.ADD.SUCCESS': 'Stroj byl úspěšně přidán',
		'MACHINE.DELETE.QUESTION': 'Opravdu chcete stroj odstranit?',
		'MACHINE.DELETE.SUCCESS': 'Stroj byl úspěšně odstraněn',
		'MACHINE.DETAILS': 'Podrobnosti o stroji',
		'MACHINE.EDIT': 'Upravit stroj',
		'MACHINE.EDIT.SUCCESS': 'Stroj úspěšně upraven',
		'MACHINE.INTERVAL.ADD': 'Přidat interval stroje',
		'MACHINE.LIVE_STATUS': 'Živý stav stroje',
		'MACHINE.NO': 'Žádný stroj',
		'MACHINE.RELOAD_POSITIONS': 'Pozice stroje pro opětovné načtení',
		'MACHINE.STATUS': 'Stav stroje',
		'MACHINES': 'Stroje',
		'MACHINES.ALL': 'Všechny stroje',
		'MACHINES.DEACTIVATE.FAILURE': 'Některé stroje nebylo možné deaktivovat.',
		'MACHINES.DEACTIVATE.QUESTION': 'Opravdu chcete vybrané stroje deaktivovat?',
		'MACHINES.DEACTIVATE.SUCCESS': 'Úspěšná deaktivace strojů',
		'MACHINES.DELETE.FAILURE': 'Opravdu chcete odstranit vybrané stroje?',
		'MACHINES.DELETE.QUESTION': 'Opravdu chcete odstranit vybrané stroje?',
		'MACHINES.DELETE.SUCCESS': 'Správa strojů',
		'MACHINES.MANAGEMENT': 'Správa strojů',
		'MACHINES.NO': 'Žádné stroje',
		'MACHINES.NOT_SELECTED': 'Žádné vybrané stroje',
		'MACHINES.NO_LICENSE.WARNING': 'Stroj nemá připojenou licenci. Bez licence nebudou zaznamenána žádná data.',
		'MACHINES.REACTIVATE.FAILURE': 'Některé stroje nebylo možné znovu aktivovat.',
		'MACHINES.REACTIVATE.QUESTION': 'Opravdu chcete vybrané stroje znovu aktivovat?',
		'MACHINES.REACTIVATE.SUCCESS': 'Úspěšná reaktivace strojů',
		'MACHINES.SELECTED': 'Vybrané stroje',
		'MACHINE_COMBINATION': 'Machine combination',
		'MACHINE_IMPLEMENT': 'Stroj/implementace',
		'MAC_DEVICES': 'Zařízení připojená k počítači',
		'MAINTENANCE': 'Údržba',
		'MAINTENANCE.AMOUNT': 'Částka na údržbu',
		'MAINTENANCE.PERIOD': 'Doba údržby',
		'MAKE': 'Výrobce',
		'MANURE': 'Hnůj',
		'MANURE.TYPE': 'Typ hnoje',
		'MAP': 'Mapa',
		'MAP.SECTION': 'Sekce mapy',
		'MAP.SECTION.CHANGE': 'Změna mapové sekce',
		'MARKER.ADD': 'Přidání nové značky',
		'MARKER.EDIT.BORDERS': 'Upravit hranice',
		'MARKER.ENTRANCE': 'Vstup',
		'MARKER.EXIT': 'Výstup',
		'MARKER.INFO': 'Informace',
		'MARKER.WARN': 'Upozornění',
		'MAX': 'Max',
		'MAX_VALUE': 'Maximální hodnota',
		'MERGE': 'Sloučení',
		'MESSAGES.NO': 'Žádné zprávy',
		'MILEAGE': 'Počet ujetých kilometrů',
		'MILEAGE.INVALID': 'Neplatný počet ujetých kilometrů',
		'MIN': 'minimum',
		'MIN_VALUE': 'Minimální hodnota',
		'MOBILE': 'Mobilní',
		'MODE.SWITCH': 'Režim přepínání',
		'MODEL': 'Model',
		'MYPROFILE': 'Můj profil',
		'MYPROFILE.BASIC_DATA': 'Základní údaje',
		'MYPROFILE.BASIC_DATA.EDIT.SUCCESS': 'Vaše základní údaje byly změněny',
		'NAME': 'Název',
		'NAV.ACTIVITIES': 'Aktivity',
		'NAV.ADMIN': 'Administrátor',
		'NAV.ADMIN.DASHBOARD': 'Přehled',
		'NAV.ADMIN.INFO_VIEW': 'Admin Info',
		'NAV.ADMIN.JOB_IMPORT_VIEW': 'Job import',
		'NAV.ADMIN.JOB_VIEW': 'Zobrazení práce',
		'NAV.ADMIN.USERS': 'Správa uživatelů',
		'NAV.CUSTOMERS': 'Zákazníci',
		'NAV.DASHBOARD': 'Přehled',
		'NAV.DATA_PREPARATION': 'Příprava dat',
		'NAV.EMPLOYEES': 'Pracovníci',
		'NAV.ENTERPRISE': 'Podnik',
		'NAV.FIELDS': 'Pole',
		'NAV.FILE_TRANSFER': 'ISO Taskdata',
		'NAV.HARDWARE': 'Adaptéry a čipy',
		'NAV.HARDWARE_SETUP': 'Nastavení hardwaru',
		'NAV.IMPLEMENTS': 'Nářadí',
		'NAV.LOCATIONS': 'Místa',
		'NAV.MACHINES': 'Stroje',
		'NAV.MY_SECTION': 'Moje sekce',
		'NAV.PATH_PLANNINGS': 'Path planning',
		'NAV.RETAILER': 'Maloobchodní prodejce',
		'NAV.SETTINGS': 'Nastavení',
		'NAV.SETTINGS.ADAPTER': 'Adaptér',
		'NAV.SETTINGS.GENERAL': 'Podnik',
		'NAV.SETTINGS.PARTNER': 'Partneři',
		'NAV.STATISTIC': 'Statistika',
		'NAV.TECH': 'TECH',
		'NAV.TRANSLATION.EDIT': 'Překlad upravit',
		'NAV.TRANSLATION_MANAGEMENT': 'Správa překladů',
		'NETWORK.ACCESS_TECHNOLOGY': 'Přístupová technologie',
		'NETWORK.OPERATOR': 'Operátor',
		'NEXT': 'Další',
		'NO': 'Ne',
		'NONE': 'Žádné',
		'NOTICE': 'Upozornění',
		'NON_PRODUCTIVE_TIME': 'Neproduktivní čas',
		'NON_PRODUCTIVE_TIMES': 'Neproduktivní časy',
		'NON_PRODUCTIVE_TIMES.SEPARATOR': 'Separator for non productive time computation',
		'NOT_READ': 'Nelze přečíst.',
		'NO_DATA': 'Žádné údaje',
		'ONLY_ON': 'Pouze na',
		'OPACITY': 'Neprůhlednost',
		'OPERATING_HOURS': 'Provozní doba',
		'OPERATING_HOURS.INVALID': 'Provozní doba neplatná',
		'OPERATION': 'Operace',
		'OPERATION.NOT_SELECTED': 'Žádná operace na vybraném poli.',
		'OPERATION.SELECT': 'Zvolte operaci',
		'OPERATIONS': 'Operace',
		'OPERATIONS.ARRIVAL': 'Příjezd',
		'OPERATIONS.CUSTOMER': 'Operace pro zákazníka',
		'OPERATIONS.FIELD': 'Operace v terénu',
		'OPERATIONS.FIELDS': 'Operace na Pole',
		'OPERATIONS.FIELD_TIME': 'Čas na poli',
		'OPERATIONS.GEOMETRY': 'Geometrie',
		'OPERATIONS.LOCATION': 'Operace na místě',
		'OPERATIONS.LOCATIONS': 'Operace na místech',
		'OPERATIONS.NO': 'Žádné operace',
		'OPERATIONS.PREPARATION': 'Příprava',
		'OVERRIDE.NO': 'Žádné přepsání',
		'PAGE': 'Page',
		'PAGE.OF': 'of',
		'PAGINATION.PER_PAGE': 'Na stránku',
		'PAGINATION.TOTAL': 'celkem',
		'PAGINATOR.FIRST_PAGE': 'První strana',
		'PAGINATOR.ITEMS_PER_PAGE': 'Položky na stránku',
		'PAGINATOR.LAST_PAGE': 'Poslední stránka',
		'PAGINATOR.NEXT_PAGE': 'Další stránka',
		'PAGINATOR.OF': 'z',
		'PAGINATOR.PREVIOUS_PAGE': 'Předchozí stránka',
		'PARTNER_CONNECTION': 'Partnerské spojení',
		'PARTNER_CONNECTION.DOES_NOT_EXPIRE': 'Nevyprší platnost',
		'PARTNER_CONNECTION.EXPIRES_ON': 'Platnost končí dne',
		'PASSWORD': 'Heslo',
		'PASSWORD.CHANGE': 'Změna hesla',
		'PASSWORD.CHANGE.ACTIVATE': 'Aktuální heslo',
		'PASSWORD.CHANGE.SUCCESS': 'Heslo bylo úspěšně změněno',
		'PASSWORD.CONFIRM': 'Potvrzení nového hesla',
		'PASSWORD.LENGTH.REQUIRED': 'Heslo musí mít alespoň 6 znaků.',
		'PASSWORD.NEW_PASSWORD': 'Nové heslo',
		'PASSWORD.NO_MATCH': 'Neshoda při potvrzování hesla!',
		'PATH_PLANNING.ADD': 'Plan path',
		'PATH_PLANNING.ADD.SUCCESS': 'Planned path successfully added',
		'PATH_PLANNING.ANGLE': 'Angle',
		'PATH_PLANNING.ANGLE.LONGEST_SIDE': 'Longest side',
		'PATH_PLANNING.ANGLE.OPTIMAL': 'Optimal',
		'PATH_PLANNING.ANGLE.WORKING': 'Working angle',
		'PATH_PLANNING.AREA.COVERED': 'Covered area',
		'PATH_PLANNING.AREA.OVERLAP': 'Overlapped area',
		'PATH_PLANNING.AREA.UNCOVERED': 'Uncovered area',
		'PATH_PLANNING.DETAILS': 'Planned path',
		'PATH_PLANNING.GENERATE_PATH': 'Generate path',
		'PATH_PLANNING.GEOMETRY.CHANGED.QUESTION': 'The field boundary has been changed. Do you want to store the boundary as the current boundary of the field?',
		'PATH_PLANNING.NAME': 'Path planning name',
		'PATH_PLANNING.NAME.EXPLANATION': 'Give the path planning a name',
		'PATH_PLANNING.NOT_ENOUGH_DATA_EXPECTATION': 'Currently there is not enough data to compute the expected fuel consumption, CO2 consumption and cost',
		'PATH_PLANNING.SELECT.FIELD': 'Select the field you want the path to be planned for',
		'PATH_PLANNING.SEND_TO_MACHINE': 'Send to machine',
		'PATH_PLANNING.SETTINGS.CHANGED.QUESTION': 'The settings have been changed after generating the currently shown planned path and will not be reflected when saved. Do you want to continue?',
		'PATH_PLANNING.SUBDIVIDE': 'Subdivide field',
		'PATH_PLANNINGS.DEACTIVATE.FAILURE': 'Some of the planned paths could not be deactivated',
		'PATH_PLANNINGS.DEACTIVATE.QUESTION': 'Do you really want to deactivate the planned path?',
		'PATH_PLANNINGS.DEACTIVATE.SUCCESS': 'Planned paths have been deactivated',
		'PATH_PLANNINGS.DELETE.FAILURE': 'Some of the planned paths could not be deleted',
		'PATH_PLANNINGS.DELETE.QUESTION': 'Do you really want to delete the planned path?',
		'PATH_PLANNINGS.DELETE.SUCCESS': 'Planned paths deleted successfully',
		'PATH_PLANNINGS.MANAGEMENT': 'Planned paths management',
		'PATH_PLANNINGS.NOT_SELECTED': 'No planned path selected',
		'PATH_PLANNINGS.REACTIVATE.FAILURE': 'Some of the planned paths could not be reactivated',
		'PATH_PLANNINGS.REACTIVATE.QUESTION': 'Do you really want to reactivate the selected planned paths?',
		'PATH_PLANNINGS.REACTIVATE.SUCCESS': 'Planned paths reactivated successfully',
		'PATTERN': 'Pattern',
		'PATTERN.END_AT_ENTRANCE': 'End at entrance',
		'PATTERN.START': 'Pattern start/end',
		'PATTERN.START_AT_ENTRANCE': 'Start at entrance',
		'PAUSE': 'Pause',
		'PERFORMANCE.AVERAGE': 'Průměrný výkon',
		'PERFORMANCE.AVERAGE.EXPLAINATION': 'Tato hodnota zohledňuje také všechny pracovní stavy, včetně doby přípravy a doby jízdy.',
		'PERFORMANCE.AVERAGE.FIELD': 'Průměrný výkon (pole)',
		'PERFORMANCE.AVERAGE.FIELD.EXPLAINATION': 'Tato hodnota zohledňuje pouze práci na poli, čekání na poli a zapnutí pole.',
		'PERFORMANCE.TOTAL': 'Celkový výkon',
		'PHONE': 'Kontaktní telefon',
		'PHONE.INVALID': 'Neplatný telefon',
		'PHONE_MOBILE': 'Telefon (mobilní)',
		'PH_VALUE': 'Hodnota PH',
		'PLAY': 'Play',
		'POSTCODE': 'Poštovní směrovací číslo (PSČ)',
		'PREVIOUS': 'Předchozí',
		'PROCESS': 'Proces',
		'PROCESSED': 'Zpracováno',
		'PROCESSED.FAILURE': 'Selhání při zpracování',
		'PROCESSED.SUCCESSFULL': 'Úspěšně zpracováno',
		'PRODUCT': 'Produkt',
		'PROGRESS': 'Progress',
		'PROJECTION': 'Projekce',
		'RAW_DATA': 'Surová data',
		'RECEIVED.AT': 'Přijato v',
		'REGENERATE': 'Regenerujte',
		'REGENERATE.SELECTED': 'Regenerovat vybrané',
		'REGISTER': 'Registrace',
		'REGISTER.ALREADY_REGISTERED?': 'Už jste se zaregistrovali?',
		'REGISTER.I_ACCEPT_THE': 'Přijímám',
		'RELOAD': 'Znovu načíst',
		'REMOVE': 'Odstranění stránky',
		'RENEW': 'Obnovit',
		'REOCURRING': 'Opakující se',
		'REPORT': 'Nahlásit',
		'RESET': 'Obnovení',
		'RESOLUTION': 'Rozlišení',
		'RESTORE.DRIVER': 'Obnovení ovladače',
		'RESTORE.IMPLEMENT': 'Obnovit implementaci',
		'ROAD': 'Silnice',
		'ROLE': 'Role',
		'RUNTIME_H': 'Doba běhu v h',
		'SAFETY_CHECK': 'Kontrola satelitu',
		'SATELITE': 'Satelit',
		'SAVE': 'Uložit',
		'SCALE.TYPE': 'Typ stupnice',
		'SEARCH': 'Vyhledávání',
		'SEASON_YEAR': 'Sezóna',
		'SEASON_YEAR.START': 'Začátek sezóny',
		'SELECT.ALL': 'Vyberte vše',
		'SELECT.CLEAR': 'Odstranění výběru',
		'SELECT.FIELD': 'Select field',
		'SENSORDATA': 'Údaje ze senzorů',
		'SENSORDATA.DESCRIPTION': 'Vizualizace senzorických dat',
		'SENSORDATA.SELECT_SENSOR': 'Výběr senzoru',
		'SENSORDATA.SHOW_WORKSTATE_COLORS': 'Zobrazit barvy pracovního stavu',
		'SENSOR_PARAMETER': 'Parametr snímače',
		'SENSOR_PARAMETER.ADD': 'Přidání parametru senzoru',
		'SENSOR_PARAMETER.DEFINE_FOR_IMPLEMENT': 'Definujte jednotlivé paremtery senzorů pro vybraný nástroj.',
		'SENSOR_PARAMETER.DEFINE_INDIVIDUAL_PARAM': 'Definujte individuální parametr senzoru.',
		'SENSOR_PARAMETER.INDIVIDUAL_SENSOR_PARAM': 'Individuální parametr snímače',
		'SENSOR_PARAMETER.NOT_REMOVABLE_USED_IN_OTHER_PARAMETER': 'Parametr senzoru je použit v jiné konfiguraci parametrů',
		'SENSOR_PARAMETERS': 'Parametry snímače',
		'SENSOR_PARAMETERS.NO': 'Žádné parametry snímače',
		'SERIAL': 'Sériové číslo',
		'SETTINGS': 'Nastavení',
		'SETTINGS.ADDITIONAL': 'Additional settings',
		'SETTINGS.ADVANCED': 'Advanced settings',
		'SETTINGS.AGRIROUTER_CAN_BE_CONNECTED': 'Váš účet Agrirouter lze propojit s exatrekem a sdílet data.',
		'SETTINGS.AGRIROUTER_CONNECTED_AND_READY': 'Agrirouter je připojen a připraven k použití. Připojení je platné, dokud',
		'SETTINGS.CONNECTION_TO_PARTNERS': 'Připojení k partnerům společnosti exatrek',
		'SETTINGS.FARMNET_FIELD_SYNC': 'Synchronizace polí z 365Farmnet do exatrek',
		'SETTINGS.FARMNET_IMPLEMENT_SYNC': 'Synchronizace Nářadí z 365Farmnet do exatrek',
		'SETTINGS.FARMNET_MACHINE_SYNC': 'Synchronizace strojů z 365Farmnet do exatreku',
		'SETTINGS.GO_TO_FARMNET': 'Přejít na 365Farmnet',
		'SETTINGS.ONLY_FARMNET_WEBAPP': 'Synchronizaci z a do 365farmnet lze použít pouze ve webové aplikaci 365farmnet.',
		'SHOW': 'Zobrazit',
		'SHOW_DIRECTION': 'Zobrazit pokyny',
		'SHOW_EVENTS': 'Zobrazit události',
		'SHOW_FIELDS': 'Zobrazit Pole',
		'SHOW_LOCATIONS': 'Zobrazit místa',
		'SHOW_OFFLINE_MACHINES': 'Zobrazit stroje offline',
		'SHOW_TRACKS': 'Zobrazit skladby',
		'SHOW_TRACKS_': 'Zobrazit skladby',
		'SNACKBAR.DAYS': 'dny',
		'SNACKBAR.LICENSE_EXPIRATION_WARNING': 'Platnost vaší licence vyprší',
		'SNACKBAR.MACHINE_ONLINE_WARNING': 'Přinejmenším jeden stroj nebyl nějakou dobu online!',
		'SORT_BY': 'Seřadit podle',
		'SPEED': 'Rychlost',
		'SPEED.AVERAGE': 'Průměrná rychlost',
		'SPEED.FASTER': 'Faster',
		'SPEED.RESET': 'Reset speed',
		'SPEED.SIGNAL.OVERRIDE': 'Přepínání rychlostních signálů',
		'SPEED.SLOWER': 'Slower',
		'SPEED.WORKING': 'Working speed',
		'SPLIT': 'Rozdělit',
		'START': 'Začátek',
		'STATISTICS': 'Statistics',
		'STATUS': 'Stav',
		'STOP': 'Konec',
		'STORAGE': 'Úložiště',
		'STORAGE.USB': 'Úložiště USB',
		'STORAGE.USB.USED': 'Použité úložiště USB',
		'STORAGE.USED': 'Použité úložiště',
		'SYMBOLIZATION': 'Symbolizace',
		'TASK': 'Úkol',
		'TASK.ADDABLE_JOBS': 'Přidatelné úlohy',
		'TASK.ADD_JOBS': 'Přidání úloh do úkolu',
		'TASK.ARCHIVED_JOB_WARNING': 'Tato úloha obsahuje archivované úlohy a nezobrazuje se celá!',
		'TASK.DELETE.JOB.FAILURE': 'Úkol musí obsahovat alespoň jednu úlohu!',
		'TASK.DELETE.JOB.QUESTION': 'Opravdu chcete odstranit úkol?',
		'TASK.DELETE.JOB.SUCCESS': 'Úloha byla úspěšně odstraněna z úlohy',
		'TASK.DELETE.QUESTION': 'Opravdu chcete úkol odstranit?',
		'TASK.DELETE.SUCCESS': 'Úloha úspěšně odstraněna',
		'TASK.EDIT': 'Upravit úkol',
		'TASK.EDIT.SUCCESS': 'Úloha byla úspěšně upravena',
		'TASK.EXPORT_DETAILS': 'Export vybrané úlohy',
		'TASK.JOBS_TO_ADD': 'Pracovní místa, která mají být přidána',
		'TASK.NEW': 'Nový úkol',
		'TASKS': 'Úkoly',
		'TASKS.NO': 'Žádné úkoly',
		'TASK_CONTROLLER.ACTIVE': 'TaskController (DataLog) aktivní',
		'TASK_CONTROLLER.COMPAT_ACTIVE': 'Režim kompatibility řadiče úloh je aktivní',
		'TAX_ID': 'Daňové identifikační číslo (DIČ)',
		'TC': 'Správce úloh',
		'TC.ACTIVE': 'TC aktivní',
		'TC.TC_COMP': 'TC komp.',
		'TERMINAL.NO': 'Žádný terminál',
		'TERMINAL.TYPE': 'Typ terminálu',
		'TEST.SUCCESS': 'Žádost byla úspěšná. Brzy obdržíte e-mail.',
		'TIME': 'Čas',
		'TIME.REMAINING': 'Zbývající čas',
		'TIMEZONE': 'Časové pásmo',
		'TITLE': 'Žádost o testovací účet',
		'TOKEN': 'Přístupový kód',
		'TOTAL': 'Celkem',
		'TRACKS.LOADING': 'Načítání stop...',
		'TRACK.WIDTH': 'Šířka rozchodu',
		'TRACK.WIDTH.NARROW': 'Úzké stránky',
		'TRACK.WIDTH.NORMAL': 'Normální',
		'TRACK.WIDTH.WIDE': 'Široký',
		'TRACK_LENGTH': 'Délka trati',
		'TRACK_REPLAY': 'Track replay',
		'TRANSLATABLE': 'Přeložitelné',
		'TRANSLATABLE.ADD': 'Přidat překládatelné',
		'TRANSLATION': 'Překlad',
		'TRANSPORT': 'Doprava',
		'TRANSPORT/AXLES': 'Doprava/nápravy',
		'TRANSPORTAMOUNT_AXLES': 'Přepravní množství/osy',
		'TURNINGS': 'Turnings',
		'TURNING_OFFSET': 'Turning offset',
		'TURNING_RADIUS': 'Turning radius',
		'TYPE': 'Typ práce',
		'UNDO': 'Zrušit',
		'UNIT': 'Jednotka',
		'UNKNOWN': 'Neznámý',
		'UNTIL': 'do',
		'UPLOAD': 'Nahrát',
		'UPLOAD.FINISHED': 'Nahrávání dokončeno',
		'UPLOADING': 'Nahrávání',
		'USER.EDIT.SUCCESS': 'Uživatel úspěšně upravil',
		'USERNAME': 'Uživatelské jméno',
		'USERNAME.LENGTH.REQUIRED': 'Uživatelské jméno musí mít alespoň 6 znaků.',
		'USERNAME.TAKEN': 'Toto jméno je již obsazeno.',
		'USERNAME.VALID.CHARS': 'Uživatelské jméno může obsahovat pouze písmena, číslice, znaky \"-\" a \"_\".',
		'USERROLE': 'Role uživatele',
		'USERSTATUS': 'Stav uživatele',
		'USER_CREATED': 'Vytvořil uživatel.',
		'WAITING': 'Čekání',
		'WARNING': 'Varování',
		'WEEK.CURRENT': 'Aktuální týden',
		'WEEK.NEXT': 'Příští týden',
		'WEEK.PREVIOUS': 'Předchozí týden',
		'WEEK.SELECTED': 'Vybraný týden',
		'WEIGHING': 'Vážení',
		'WIDTH.INVALID': 'Neplatná šířka',
		'WORKING_HOURS': 'Pracovní doba',
		'WORKING_TIME': 'Pracovní doba',
		'WORKING_WIDTH': 'Pracovní šířka',
		'WORKSTATE': 'Pracovní stav',
		'WORKSTATES': 'Pracovní místa',
		'YES': 'Ano',
    'NO_POSITION_MACHINE_FOUND': 'Nenalezeno',
	}
};
